/* eslint-disable */
import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import {
  Tabs,
  Tooltip,
  Switch,
  Tab,
  TableContainer,
  Checkbox,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  MenuItem,
  Button,
  Typography,
  Grid,
  Paper,
  Divider,
  Snackbar,
} from "@material-ui/core";
import { ThreeDots } from "react-loader-spinner";
import AddCircle from "@material-ui/icons/AddCircle";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import cx from "classnames";
import { saveAs } from "file-saver";
import MuiAlert from "@material-ui/lab/Alert";

/* novas */
import { fixedFieldRenderers } from "components/FormHelper/fixedFieldRenderers";
import LegacyInitialInfo from "components/FormHelper/LegacyInitialInfo";

import AssignmentTurnedInRounded from "@material-ui/icons/AssignmentTurnedInRounded";
import CloudDownloadRounded from "@material-ui/icons/CloudDownloadRounded";
import CloudUploadRounded from "@material-ui/icons/CloudUploadRounded";
import InsertDriveFile from "@material-ui/icons/InsertDriveFile";
import SearchIcon from "@material-ui/icons/Search";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { Section } from "components/Section/Section";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { makeStyles } from "@material-ui/core/styles";
import Save from "@material-ui/icons/Save";
import styles from "../../assets/jss/material-dashboard-pro-react/views/newInitiativesStyle.js";
import { useTranslation } from "react-i18next";
import moment from "moment";
import ReactSelect from "react-select";
import AuthContext from "../../contexts/AuthProvider.js";
import { client } from "../../services/axiosClient";
import { getAltLabel } from "utils/getAltLabel";

export default function NewInitiativeForm({
  initiativeToEdit,
  onCloseDrawer, // <-- ADD THIS
  onReloadInitiatives,
}) {
  const { userDetails, authTokens } = useContext(AuthContext); // Assegure-se de que o token está disponível
  const token = authTokens?.access; // Extrai o token de acesso dos authTokens
  const hasInitialized = useRef(false); // Controla se já foi inicializado
  const editFormDataRef = useRef(null); // Controla se o formData já foi preenchido para uma iniciativa específica
  
  // Debug para verificar o que está chegando do AuthContext
  console.log("🔍 AuthContext Debug:", {
    userDetails: !!userDetails,
    authTokens: !!authTokens,
    token: !!token,
    authTokensKeys: authTokens ? Object.keys(authTokens) : 'null'
  });
  const client_styles = (theme) => ({
    ...styles(theme, userDetails.implementation_color),
  });
  const useStyles = makeStyles(client_styles);
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const clientColor = userDetails?.implementation_color;

  useEffect(() => {
    moment.locale(i18n.language);
  }, [i18n.language]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "80px",
      maxHeight: "80px",
      overflowY: "auto",
      outline: "none",
      boxSizing: "border-box",
      borderColor: state.isFocused ? clientColor : provided.borderColor,
      backgroundColor: "white",
      boxShadow: state.isFocused ? `0 0 0 1px ${clientColor}` : "none",
      "&:hover": {
        borderColor: clientColor,
      },
    }),
    menu: (provided) => ({
      ...provided,
      overflowY: "auto",
      backgroundColor: "white",
      boxSizing: "border-box",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "black" : state.isFocused ? "white" : "black",
      backgroundColor: state.isSelected
        ? "gray"
        : state.isFocused
          ? clientColor
          : "white",
      "&:active": {
        transform: "scale(0.95)",
        transition: "transform 0.2s ease",
        backgroundColor: clientColor,
      },
    }),

    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#d3d3d3",
    }),

    multiValueLabel: (provided) => ({
      ...provided,
      color: "black",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "black",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };
  useEffect(() => {
    if (userDetails) {
      console.log("DEBUG userDetails carregados");
    }
  }, [userDetails]); // Executa quando userDetails muda

  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({
    initiativeName: "",
    initiativeLeader: "",
    initiativeLeader2: "",
    initiativePmo: "",
    integrationOwner: "",
    sponsor: "",
    branch: "",
    workfront: "",
    description: "",
    descriptionKpi: "",
    kpiName: "",
    accessGroup: [],
    tags: [],
    initiativeImpact: [],
    risks: "",
  });

  //States for API data
  const [branches, setBranches] = useState([]);
  const [workfronts, setWorkfronts] = useState([]);
  const [accessGroups, setAccessGroups] = useState([]);
  const [tags, setTags] = useState([]);
  const [initiativeImpacts, setInitiativeImpacts] = useState([]);
  const [users, setUsers] = useState([]);
  const [kpis, setKpis] = useState([]);
  const [customFields, setCustomFields] = useState([]);

  const [isLoading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [errorsAddKpi, setErrorsAddKpi] = useState({});

  //Additional States
  const [showOnlySelected, setShowOnlySelected] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredKpis, setFilteredKpis] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isCreateKpiOpen, setIsCreateKpiOpen] = useState(false);
  const [selectedImpact, setSelectedImpact] = useState([]);
  const [selectedAccessGroups, setSelectedAccessGroups] = useState([]);
  const [selectedUsersInitiative, setSelectedUsersInitiative] = useState([]);
  const [selectedUsersImp, setSelectedUsersImp] = useState([]);
  const [selectedUsersResults, setSelectedUsersResults] = useState([]);
  const [selectedKpis, setSelectedKpis] = useState([]);
  const [fileUploadedBC, setFileUploadedBC] = useState(false);
  const [fileUploadedImp, setFileUploadedImp] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  const initialSpecificKpiState = {
    name: "",
    performance_orientation: "",
    subtype: "",
    description: "",

    green_threshold_value: "",
    green_max_value: "", // Apenas para MOD Green

    yellow_threshold_value: "", // Usado como Min para MOD Yellow (faixa 1) e ASC/DESC Yellow
    yellow_max_value: "", // Usado como Max para MOD Yellow (faixa 1) e ASC/DESC Yellow

    // Campos para a SEGUNDA FAIXA OPCIONAL (somente para MODULAR YELLOW)
    yellow_min_value_2: "",
    yellow_max_value_2: "",

    // Campos para RED
    red_threshold_value: "", // Usado para valor único em ASC (Below) / DESC (Above) Red
    red_modular_below_value: "", // Usado para MOD Red (< P)
    red_modular_above_value: "", // Usado para MOD Red (> Q)
  };

  const [newKpi, setNewKpi] = useState(initialSpecificKpiState);
  const [uploadedFiles, setUploadedFiles] = useState({
    kpiFile: null,
    implementationFile: null,
    businessCaseFile: null,
  });
  // eslint-disable-next-line no-unused-vars
  const [apiError, setApiError] = useState(null);

  //Mapping for ReactSelect
  const tagOptions = tags.map((tag) => ({ value: tag, label: tag }));
  const impactOptions = initiativeImpacts.map((impact) => ({
    value: impact,
    label: impact,
  }));
  const accessOptions = accessGroups.map((group) => ({
    value: group,
    label: group,
  }));
  const userOptions = users.map((user) => ({
    value: user.email,
    label: `${user.name} (${user.email})`,
  }));

  const kpiPerformanceOptions = [
    { value: "ASC", label: t("new_initiatives.fields.ascending") },
    { value: "DESC", label: t("new_initiatives.fields.descending") },
    { value: "MOD", label: t("new_initiatives.fields.modular") },
  ];

  const kpiSubTypeOptions = [
    {
      value: "topo",
      label: t("new_initiatives.fields.topo", "Topo"),
    }, // Default to "Topo" if translation missing
    {
      value: "financial",
      label: t("new_initiatives.fields.financial", "Financial"),
    }, // Default to "Financial"
    {
      value: "budget",
      label: t("new_initiatives.fields.budget", "Budget"),
    }, // Default to "Budget"
    {
      value: "specific",
      label: t("new_initiatives.fields.specific", "Specific"),
    }, // Default to "Specific"
  ];

  const MAX_ATTACHMENTS = 5;
  const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB
  const [attachments, setAttachments] = useState([]);
  const [attachmentError, setAttachmentError] = useState("");
  // useEffect para carregar dados básicos da aplicação (executa apenas uma vez)
  useEffect(() => {
    if (!token || hasInitialized.current) {
      return;
    }

    const fetchInitiativeSetupData = async () => {
      try {
        console.log("📡 Carregando dados básicos da aplicação...");
        const response = await client.post("api/initiatives_set_up/");

        if (response.data.success) {
          const data = response.data.data;
          console.log("✅ Dados básicos carregados:", {
            branches: data.branches?.length || 0,
            workfronts: data.workfronts?.length || 0,
            accessGroups: data.accessGroups?.length || 0,
            tags: data.tags?.length || 0,
            initiativeImpacts: data.initiativeImpacts?.length || 0,
            users: data.users?.length || 0,
            kpis: data.kpis?.length || 0,
            customFields: data.customFields?.length || 0
          });
          
          setBranches(data.branches || []);
          setWorkfronts(data.workfronts || []);
          setAccessGroups(data.accessGroups || []);
          setTags(data.tags || []);
          setInitiativeImpacts(data.initiativeImpacts || []);
          setUsers(data.users || []);

          const initiativeReportableKpis = (data.kpis || []).filter(
            (kpi) => kpi.reporting_format !== "centralized"
          );

          setKpis(initiativeReportableKpis);
          setFilteredKpis(initiativeReportableKpis);
          setCustomFields(data.customFields || []);
          
          hasInitialized.current = true;
          setLoading(false);
        } else {
          console.error("❌ Erro ao carregar dados básicos:", response.data);
          setError("Falha ao obter os dados da aplicação.");
          setLoading(false);
        }
      } catch (err) {
        console.error("❌ Erro ao carregar dados básicos:", err);
        setError("Erro ao carregar dados da aplicação.");
        setLoading(false);
      }
    };
    
    fetchInitiativeSetupData();
  }, [token]); // Executa apenas quando o token muda

  useEffect(() => {
    setFilteredKpis(kpis);
  }, [kpis]);

  //Filter and Research Management
  useEffect(() => {
    // Só executa se kpis estiverem carregados
    if (kpis.length === 0) return;
    
    let filtered = [...kpis];

    //Filter by Research Agreement
    if (searchTerm) {
      filtered = filtered.filter((kpi) =>
        kpi.name.toLowerCase().includes(searchTerm)
      );
    }

    if (showOnlySelected) {
      filtered = filtered.filter((kpi) => selectedKpis.includes(kpi.id));
    }

    setFilteredKpis(filtered);
  }, [searchTerm, showOnlySelected, selectedKpis, kpis]);

  const renderCustomFields = () => {
    if (!customFields || customFields.length === 0) return null;

    /* ——— helper para escolher quantas colunas cada tipo ocupa ——— */
    const getGridSizes = (type) => {
      const fullWidth = ["multichoices", "text"];
      return fullWidth.includes(type)
        ? { xs: 12, sm: 12, md: 12 } // ocupa a linha inteira
        : { xs: 12, sm: 6, md: 4 }; // divide em 2–3 colunas
    };

    return customFields.map((field) => {
      const {
        field_name,
        field_label,
        label_key,
        field_type,
        is_required,
        choices = [],
      } = field;

      const label = label_key ? t(`${label_key}`) : field_label;

      const handleChange = (e) => {
        const value =
          field_type === "boolean" ? e.target.checked : e.target.value;
        setCustomFieldValues((prev) => ({ ...prev, [field_name]: value }));
        if (initiativeToEdit) setHasChanges(true);
      };

      /* tamanhos responsivos calculados */
      const sizeProps = getGridSizes(field_type);

      switch (field_type) {
        /* ——— TEXT / CHAR / NUMBER / DATE ——— */
        case "text":
        case "char":
        case "number":
        case "date":
          return (
            <GridItem
              {...sizeProps}
              key={field_name}
              style={{ marginBottom: 16 }}
            >
              <TextField
                fullWidth
                label={label}
                name={field_name}
                type={field_type === "number" ? "number" : field_type}
                value={customFieldValues[field_name] || ""}
                required={is_required}
                onChange={handleChange}
                classes={{ root: classes.textFieldRoot }}
                InputProps={{ classes: { input: classes.inputText } }}
                InputLabelProps={{
                  classes: { root: classes.labelText },
                }}
              />
            </GridItem>
          );

        /* ——— CHOICE (dropdown) ——— */
        case "choice":
          return (
            <GridItem
              {...sizeProps}
              key={field_name}
              style={{ marginBottom: 16 }}
            >
              <TextField
                select
                fullWidth
                label={label}
                name={field_name}
                value={customFieldValues[field_name] || ""}
                required={is_required}
                onChange={handleChange}
                classes={{ root: classes.textFieldRoot }}
                InputProps={{ classes: { input: classes.inputText } }}
                InputLabelProps={{ classes: { root: classes.labelText } }}
              >
                {choices.map((opt, idx) => (
                  <MenuItem
                    key={idx}
                    value={opt}
                    classes={{
                      root: classes.selectMenuItem,
                      selected: classes.selectMenuItemSelected,
                    }}
                  >
                    {opt}
                  </MenuItem>
                ))}
              </TextField>
            </GridItem>
          );

        /* ——— MULTI‑CHOICES ——— */
        case "multichoices": {
          const multiChoicesOptions =
            typeof choices === "string"
              ? choices.split(";").map((o) => {
                  const v = o.trim();
                  return { label: v, value: v };
                })
              : Array.isArray(choices)
                ? choices.map((o) => ({
                    label: String(o).trim(),
                    value: String(o).trim(),
                  }))
                : [];

          return (
            <GridItem
              {...sizeProps}
              key={field_name}
              style={{ marginLeft: "-8px", marginBottom: "10px" }}
            >
              <div className={classes.multiSelectContainer}>
                <label
                  className={classes.labelMultiSelect}
                  style={{ marginBottom: 8 }}
                >
                  {label}
                </label>
                <ReactSelect
                  isMulti
                  options={multiChoicesOptions}
                  value={
                    Array.isArray(customFieldValues[field_name])
                      ? customFieldValues[field_name].map((v) => ({
                          value: v,
                          label: v,
                        }))
                      : []
                  }
                  onChange={(selected) => {
                    const vals = selected.map((s) => s.value);
                    setCustomFieldValues((prev) => ({
                      ...prev,
                      [field_name]: vals,
                    }));
                    if (initiativeToEdit) setHasChanges(true);
                  }}
                  styles={customStyles}
                  placeholder={t("new_initiatives.fields.select_label")}
                  closeMenuOnSelect={false}
                />
              </div>
            </GridItem>
          );
        }

        /* ——— BOOLEAN ——— */
        case "boolean":
          return (
            <GridItem
              {...sizeProps}
              key={field_name}
              style={{ marginBottom: 16 }}
            >
              <div className={classes.switchContainer}>
                <Typography className={classes.labelSwitch}>
                  {field_label}
                </Typography>
                <Switch
                  checked={customFieldValues[field_name] || false}
                  onChange={handleChange}
                  name={label}
                  classes={{
                    switchBase: classes.switchBase,
                    track: classes.track,
                  }}
                />
              </div>
            </GridItem>
          );

        default:
          return null;
      }
    });
  };

  const getGridSizes = (type) => {
    const fullWidth = ["multichoices", "text"];
    return fullWidth.includes(type)
      ? { xs: 12, sm: 12, md: 12 } // pega linha inteira
      : { xs: 12, sm: 6, md: 4 }; // divide em duas / três colunas
  };

  /* ------------------------------------------------------------------ */
  /* Helper: devolve o JSX de 1 custom field                            */
  /* ------------------------------------------------------------------ */
  const renderSingleCustomField = (meta) => {
    const {
      field_name,
      field_label,
      label_key,
      field_type,
      is_required,
      choices = [],
    } = meta;

    const label = label_key ? t(`${label_key}`) : field_label;

    /* valor daquele campo dentro do form */
    const fieldValue =
      customFieldValues[field_name] ?? (field_type === "boolean" ? false : "");

    const handleChange = (value) => {
      setCustomFieldValues((prev) => ({ ...prev, [field_name]: value }));
      if (initiativeToEdit) setHasChanges(true);
    };

    /* ------------- switch pelo tipo --------------------------------- */
    switch (field_type) {
      case "text":
      case "char":
      case "number":
      case "date":
        return (
          <GridItem
            style={{ marginBottom: 16 }}
            key={field_name}
            {...getGridSizes(field_type)}
          >
            <TextField
              fullWidth
              label={label}
              name={field_name}
              type={field_type === "number" ? "number" : field_type}
              value={fieldValue}
              required={is_required}
              onChange={(e) => handleChange(e.target.value)}
              classes={{ root: classes.textFieldRoot }}
              InputProps={{ classes: { input: classes.inputText } }}
              InputLabelProps={{ classes: { root: classes.labelText } }}
            />
          </GridItem>
        );

      case "choice":
        return (
          <GridItem
            style={{ marginBottom: 16 }}
            key={field_name}
            {...getGridSizes(field_type)}
          >
            <TextField
              select
              fullWidth
              label={label}
              name={field_name}
              value={fieldValue}
              required={is_required}
              onChange={(e) => handleChange(e.target.value)}
              classes={{ root: classes.textFieldRoot }}
              InputProps={{ classes: { input: classes.inputText } }}
              InputLabelProps={{ classes: { root: classes.labelText } }}
            >
              {choices.map((opt) => (
                <MenuItem key={opt} value={opt}>
                  {opt}
                </MenuItem>
              ))}
            </TextField>
          </GridItem>
        );

      case "multichoices": {
        /* 1) opções vindas do back */
        const options = choices.map((c) => ({ value: c, label: c }));

        /* 2) garante que o valor seja sempre um array */
        let current = fieldValue;
        if (Array.isArray(current)) {
          /* OK */
        } else if (typeof current === "string" && current.trim() !== "") {
          /* veio "Area 1;Area 2"  ou  "Area 1,Area 2"  */
          current = current.split(/[,;]+/).map((s) => s.trim());
        } else {
          current = [];
        }

        return (
          <GridItem
            style={{ marginBottom: 16 }}
            key={field_name}
            {...getGridSizes(field_type)}
          >
            <div className={classes.multiSelectContainer}>
              <label className={classes.labelMultiSelect}>{label}</label>
              <ReactSelect
                isMulti
                options={options}
                value={current.map((v) => ({ value: v, label: v }))}
                onChange={(sel) => handleChange(sel.map((s) => s.value))}
                styles={customStyles}
                placeholder={t("new_initiatives.fields.select_label")}
                closeMenuOnSelect={false}
              />
            </div>
          </GridItem>
        );
      }

      case "boolean":
        return (
          <GridItem
            style={{ marginBottom: 16 }}
            key={field_name}
            {...getGridSizes(field_type)}
          >
            <div className={classes.switchContainer}>
              <Typography className={classes.labelSwitch}>{label}</Typography>
              <Switch
                checked={fieldValue}
                onChange={(e) => handleChange(e.target.checked)}
                classes={{
                  switchBase: classes.switchBase,
                  track: classes.track,
                }}
              />
            </div>
          </GridItem>
        );

      default:
        return null;
    }
  };

  const handleAttachmentsChange = (event) => {
    setAttachmentError("");

    //stores the new selected files in a array
    const files = Array.from(event.target.files);
    if (!files || files.length === 0) return;

    //check if we already have x attachments
    if (attachments.length + files.length > MAX_ATTACHMENTS) {
      setAttachmentError(
        `Você já tem ${attachments.length} arquivos anexados. Só pode enviar até ${MAX_ATTACHMENTS} no total.`
      );
      return;
    }

    //itra on each selected file to check size and insert
    const validFiles = [];
    for (const file of files) {
      if (file.size > MAX_FILE_SIZE) {
        //If any file exceeds the size, you can discard or stop everything. Here, I will discard only the file
        setAttachmentError(
          t("new_initiatives.fields.attachment_file_exceeds_size", {
            fileName: file.name,
            maxSize: (MAX_FILE_SIZE / (1024 * 1024)).toFixed(2),
          })
        );
      } else {
        validFiles.push({
          file: file,
          name: file.name,
          size: file.size,
        });
      }
    }

    //Add states valid to the state
    setAttachments((prev) => [...prev, ...validFiles]);

    //reset the value of the input to allow re-select the same file if you want
    event.target.value = null;
  };

  const [deletedFiles, setDeletedFiles] = useState({
    bc: false, // Business Case deletado?
    imp: false, // Implementation Plan deletado?
    extras: [], // array de índices OU blob_names removidos
  });

  const handleRemoveAttachment = (idx) => {
    setAttachments((prev) => {
      const removed = prev[idx];
      setDeletedFiles((p) => ({
        ...p,
        extras: [...p.extras, removed.blobName], // agora é o blob real
      }));
      return prev.filter((_, i) => i !== idx);
    });
  };

  const removeBusinessCase = () => {
    setUploadedFiles((p) => ({ ...p, businessCaseFile: null }));
    setFileUploadedBC(false);
    setDeletedFiles((p) => ({ ...p, bc: true }));
  };

  const removeImpPlan = () => {
    setUploadedFiles((p) => ({ ...p, implementationFile: null }));
    setFileUploadedImp(false);
    setDeletedFiles((p) => ({ ...p, imp: true }));
  };

  // Handlers
  const handleSelectKpi = (kpiId) => {
    setSelectedKpis(
      (prevSelectedKpis) =>
        prevSelectedKpis.includes(kpiId)
          ? prevSelectedKpis.filter((id) => id !== kpiId) // Se já estava selecionado, remove
          : [...prevSelectedKpis, kpiId] // Se não estava, adiciona
    );
  };

  const [uploadError, setUploadError] = useState({});
  const [impPlanError, setImpPlanError] = useState(null);
  const [impPlanLoading, setImpPlanLoading] = useState(false);

  const handleKpiUploadError = (kpiId, errorCode) => {
    const errorMessage = t(`kpi_upload.errors.${errorCode}`);
    setUploadError(kpiId, errorMessage);
  };

  const handleUploadFileKpi = (kpiId, event) => {
    if (!event || !event.target || !event.target.files) {
      console.error("Erro: Nenhum arquivo foi selecionado.");
      return;
    }

    const file = event.target.files[0];
    if (!file) {
      console.error("Erro: Arquivo inválido.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("kpi_id", kpiId);

    // Limpa erro anterior se houver
    setUploadError((prev) => ({ ...prev, [kpiId]: null }));
    setButtonLoading(kpiId, "uploadFile", true);

    client.post("/api/awake/").then(() => {
      client
        .post("/api/process_kpi_file/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.data.success) {
            console.log("✅ Dados processados:", response.data.data);
            setUploadedFiles((prevFiles) => ({
              ...prevFiles,
              [kpiId]: {
                file,
                plannedValues: response.data.data,
                fileUrl: response.data.temp_file_url,
                blobName: response.data.blob_name,
              },
            }));
          } else {
            const errorCode = response.data.error_code || "internal_error";
            setUploadError((prev) => ({ ...prev, [kpiId]: errorCode }));
            console.error(
              "❌ Erro ao processar o arquivo:",
              response.data.error
            );
          }
        })
        .catch((error) => {
          const errorCode =
            error.response?.data?.error_code || "internal_error";
          setUploadError((prev) => ({ ...prev, [kpiId]: errorCode }));
          console.error("❌ Erro ao fazer upload do arquivo:", error);
        })
        .finally(() => {
          setButtonLoading(kpiId, "uploadFile", false);
        });
    });
  };

  const validateFieldsAddKpi = () => {
    const newErrors = {};

    if (!newKpi.name)
      newErrors.name = t("new_initiatives.fields.required_field");
    if (!newKpi.type)
      newErrors.type = t("new_initiatives.fields.required_field");
    if (!newKpi.subtype)
      newErrors.subtype = t("new_initiatives.fields.required_field");

    // Se o KPI tiver thresholds (acima/abaixo/entre), validar os valores
    ["green", "yellow", "red"].forEach((color) => {
      const condition = newKpi[`${color}Condition`];

      if (!condition) return; // Se não há condição, não precisa validar

      if (condition === "Above" || condition === "Below") {
        if (
          newKpi[`${color}Threshold`] === "" ||
          newKpi[`${color}Threshold`] === null ||
          newKpi[`${color}Threshold`] === undefined
        ) {
          newErrors[`${color}Threshold`] = t(
            "new_initiatives.fields.required_field"
          );
        }
      }

      if (condition === "Between") {
        if (
          newKpi[`${color}Min`] === "" ||
          newKpi[`${color}Min`] === null ||
          newKpi[`${color}Min`] === undefined
        ) {
          newErrors[`${color}Min`] = t("new_initiatives.fields.required_field");
        }
        if (
          newKpi[`${color}Max`] === "" ||
          newKpi[`${color}Max`] === null ||
          newKpi[`${color}Max`] === undefined
        ) {
          newErrors[`${color}Max`] = t("new_initiatives.fields.required_field");
        }
      }
    });

    setErrorsAddKpi(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const isButtonDisabled = (kpiId, buttonType) => {
    const isKpiSelected = selectedKpis.includes(kpiId);

    if (!isKpiSelected) return true;

    if (buttonType === "downloadUploadedFile") {
      return !uploadedFiles[kpiId];
    }

    return false;
  };

  const handleUploadBusinessCase = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUploadedFiles((prev) => ({ ...prev, businessCaseFile: file })); // Atualiza o estado com o arquivo de business case
      setFileUploadedBC(true); // Atualiza o estado para indicar que o arquivo foi enviado
    }
  };

  const [uploadedImplementationData, setUploadedImplementationData] = useState(
    []
  );

  // const handleUploadImpPlan = (event) => {
  //   setFileUploadedImp(true);
  //   if (!event || !event.target || !event.target.files) {
  //     console.error("Erro: Nenhum arquivo foi selecionado.");
  //     return;
  //   }

  //   const file = event.target.files[0];
  //   if (!file) {
  //     console.error("Erro: Arquivo inválido.");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("file", file);

  //   client.post("/api/awake/").then(() => {
  //     client
  //       .post("/api/process_implementation_file/", formData, {
  //         headers: { "Content-Type": "multipart/form-data" },
  //       })
  //       .then((response) => {
  //         if (response.data.success) {
  //           console.log(
  //             "✅ Dados do Plano de Implementação processados:",
  //             response.data.data
  //           );
  //           setUploadedImplementationData(response.data.data);
  //           setUploadedFiles((prev) => ({
  //             ...prev,
  //             implementationFile: file,
  //           }));
  //           setFileUploadedImp(true);
  //         } else {
  //           console.error(
  //             "❌ Erro ao processar o arquivo:",
  //             response.data.error
  //           );
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("❌ Erro ao fazer upload do arquivo:", error);
  //       });
  //   });
  // };

  const handleUploadImpPlan = (event) => {
    if (!event?.target?.files?.length) return;

    const file = event.target.files[0];
    setImpPlanError(null);
    setImpPlanLoading(true);

    const formData = new FormData();
    formData.append("file", file);

    client.post("/api/awake/").then(() => {
      client
        .post("/api/process_implementation_file/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (res.data.success) {
            /* ✓ sucesso */
            setUploadedImplementationData(res.data.data);
            setUploadedFiles((p) => ({ ...p, implementationFile: file }));
            setFileUploadedImp(true);
          } else {
            /* ✗ erro vindo da API */
            const code = res.data.error_code || "upload.errors.internal_error";
            setImpPlanError(t(code, { defaultValue: res.data.message }));
            setFileUploadedImp(false);
          }
        })
        .catch((err) => {
          const code =
            err.response?.data?.error_code || "upload.errors.internal_error";
          const msg = err.response?.data?.message || err.message;
          setImpPlanError(t(code, { defaultValue: msg }));
          setFileUploadedImp(false);
        })
        .finally(() => setImpPlanLoading(false));
    });
  };

  const handleDownloadImpPlan = () => {
    client.post("/api/awake/").then(() => {
      client
        .post(
          "/api/generate_implementation_template/",
          { initiative_id: initiativeToEdit?.id || "new" },
          {
            headers: { "Content-Type": "application/json" },
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "ImplementationPlan_Template.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("Erro ao baixar template:", error);
        });
    });
  };

  const [isSavingKpi, setIsSavingKpi] = useState(false); // Estado para indicar que está salvando
  // eslint-disable-next-line no-unused-vars

  const [customFieldValues, setCustomFieldValues] = useState({});

  const handleSaveNewKpi = async () => {
    // Validação básica (adapte se necessário, o validateFieldsAddKpi original era mais completo)
    const tempErrors = {};
    if (!newKpi.name)
      tempErrors.name = t("new_initiatives.fields.required_field");
    if (!newKpi.performance_orientation)
      tempErrors.performance_orientation = t(
        "new_initiatives.fields.required_field"
      );
    if (!newKpi.subtype)
      tempErrors.subtype = t("new_initiatives.fields.required_field");
    // Adicionar validação para os campos de threshold se a orientação exigir
    // Ex: se performance_orientation é ASC e green_min_value está vazio

    // VALIDAÇÃO DOS THRESHOLDS (similar à sua validateFieldsAddKpi original)
    const orientation = newKpi.performance_orientation;
    if (orientation) {
      // Só valida se uma orientação foi escolhida
      const colorsToCheck = ["green", "yellow", "red"];
      colorsToCheck.forEach((color) => {
        let conditionForColor = "";
        if (orientation === "ASC") {
          if (color === "green") conditionForColor = "Above";
          else if (color === "yellow") conditionForColor = "Between";
          else if (color === "red") conditionForColor = "Below";
        } else if (orientation === "DESC") {
          if (color === "green") conditionForColor = "Below";
          else if (color === "yellow") conditionForColor = "Between";
          else if (color === "red") conditionForColor = "Above";
        } else if (orientation === "MOD") {
          conditionForColor = "Between"; // Faixa principal
        }

        if (conditionForColor === "Above" || conditionForColor === "Below") {
          if (!newKpi[`${color}_threshold_value`]) {
            // Ex: green_threshold_value ou red_threshold_value
            tempErrors[`${color}_threshold_value`] = t(
              "new_initiatives.fields.required_field"
            );
          }
        } else if (conditionForColor === "Between") {
          if (!newKpi[`${color}_threshold_value`]) {
            // Min para between
            tempErrors[`${color}_threshold_value`] = t(
              "new_initiatives.fields.required_field"
            );
          }
          if (!newKpi[`${color}_max_value`]) {
            // Max para between
            tempErrors[`${color}_max_value`] = t(
              "new_initiatives.fields.required_field"
            );
          }
        }
        // Validação para segunda faixa do MODULAR (Yellow e Red)
        if (orientation === "MOD" && (color === "yellow" || color === "red")) {
          // Se um campo da segunda faixa estiver preenchido, o outro também deve estar
          const min2 = newKpi[`${color}_min_value_2`];
          const max2 = newKpi[`${color}_max_value_2`];
          if ((min2 && !max2) || (!min2 && max2)) {
            if (!min2)
              tempErrors[`${color}_min_value_2`] = t(
                "new_initiatives.fields.start_end_message"
              );
            if (!max2)
              tempErrors[`${color}_max_value_2`] = t(
                "new_initiatives.fields.start_end_message"
              );
          } else if (min2 && max2 && parseFloat(min2) > parseFloat(max2)) {
            tempErrors[`${color}_min_value_2`] = t(
              "new_initiatives.fields.date_invalid_message"
            ); // Reutilizando mensagem de erro
            tempErrors[`${color}_max_value_2`] = t(
              "new_initiatives.fields.date_invalid_message"
            );
          }
        }
        // Validação para Red Modular (Abaixo de P OU Acima de Q)
        if (orientation === "MOD" && color === "red") {
          if (
            !newKpi.red_modular_below_value &&
            !newKpi.red_modular_above_value
          ) {
            // Pelo menos um dos campos deve ser preenchido para Red Modular
            tempErrors.red_modular_below_value = t(
              "new_initiatives.fields.at_least_one_required"
            );
            tempErrors.red_modular_above_value = t(
              "new_initiatives.fields.at_least_one_required"
            );
          }
        }
      });
    }

    if (Object.keys(tempErrors).length > 0) {
      setErrorsAddKpi(tempErrors);
      console.log(
        "🚨 Campos obrigatórios de KPI não preenchidos no modal!",
        tempErrors
      );
      setIsSavingKpi(false);
      return;
    }
    setErrorsAddKpi({});
    setIsSavingKpi(true);

    const thresholdsToSend = [];
    // const orientation = newKpi.performance_orientation; // Já definido acima

    const parseVal = (valStr) => {
      if (valStr === "" || valStr === null || valStr === undefined) return null;
      const num = parseFloat(valStr);
      return isNaN(num) ? null : num / 100;
    };

    // GREEN
    if (orientation === "ASC") {
      if (newKpi.green_min_value)
        thresholdsToSend.push({
          color: "green",
          mode: "above",
          min_value: parseVal(newKpi.green_min_value),
          max_value: null,
        });
    } else if (orientation === "DESC") {
      if (newKpi.green_min_value)
        thresholdsToSend.push({
          color: "green",
          mode: "below",
          min_value: null,
          max_value: parseVal(newKpi.green_min_value),
        });
    } else if (orientation === "MOD") {
      if (newKpi.green_min_value || newKpi.green_max_value) {
        thresholdsToSend.push({
          color: "green",
          mode: "between",
          min_value: parseVal(newKpi.green_min_value),
          max_value: parseVal(newKpi.green_max_value),
        });
      }
    }

    // YELLOW
    if (newKpi.yellow_min_value_1 || newKpi.yellow_max_value_1) {
      thresholdsToSend.push({
        color: "yellow",
        mode: "between",
        min_value: parseVal(newKpi.yellow_min_value_1),
        max_value: parseVal(newKpi.yellow_max_value_1),
      });
    }
    if (
      orientation === "MOD" &&
      (newKpi.yellow_min_value_2 || newKpi.yellow_max_value_2)
    ) {
      thresholdsToSend.push({
        color: "yellow",
        mode: "between",
        min_value: parseVal(newKpi.yellow_min_value_2),
        max_value: parseVal(newKpi.yellow_max_value_2),
      });
    }

    // RED
    if (orientation === "ASC") {
      if (newKpi.red_threshold_value)
        thresholdsToSend.push({
          color: "red",
          mode: "below",
          min_value: null,
          max_value: parseVal(newKpi.red_threshold_value),
        });
    } else if (orientation === "DESC") {
      if (newKpi.red_threshold_value)
        thresholdsToSend.push({
          color: "red",
          mode: "above",
          min_value: parseVal(newKpi.red_threshold_value),
          max_value: null,
        });
    } else if (orientation === "MOD") {
      if (newKpi.red_modular_below_value) {
        thresholdsToSend.push({
          color: "red",
          mode: "below",
          min_value: null,
          max_value: parseVal(newKpi.red_modular_below_value),
        });
      }
      if (newKpi.red_modular_above_value) {
        thresholdsToSend.push({
          color: "red",
          mode: "above",
          min_value: parseVal(newKpi.red_modular_above_value),
          max_value: null,
        });
      }
    }

    try {
      const response = await client.post("/api/create_specific_kpi/", {
        name: newKpi.name,
        subtype: newKpi.subtype,
        description: newKpi.description,
        performance_orientation: newKpi.performance_orientation,
        // is_cumulative: newKpi.is_cumulative, // Se for controlar aqui
        thresholds: thresholdsToSend,
      });

      if (response.data.success) {
        console.log(
          "KPI específico criado com sucesso:",
          response.data.message
        );
        const updatedKpisFromBackend = response.data.kpis;
        setKpis(updatedKpisFromBackend);
        // setFilteredKpis(updatedKpisFromBackend); // Se você usar este estado separadamente
        setIsCreateKpiOpen(false);
        setNewKpi(initialSpecificKpiState); // Reset usando o estado inicial correto
        setHasChanges(false);
        toast.success(
          t(
            "new_initiatives.kpi_messages.create_success",
            "KPI created successfully!"
          )
        ); // Adicionar tradução
      } else {
        console.error("Erro ao criar KPI específico:", response.data.message);
        toast.error(
          response.data.message ||
            t("new_initiatives.kpi_errors.save_failed", "Failed to create KPI.")
        );
      }
    } catch (error) {
      console.error("Erro ao salvar o KPI específico:", error);
      toast.error(
        t(
          "new_initiatives.kpi_errors.save_failed_catch",
          "An error occurred while saving the KPI."
        )
      );
    } finally {
      setIsSavingKpi(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    console.log(`🕵️ Atualizando estado -> ${name}: ${value}`);
  };

  const handleNewKpiChange = (event) => {
    const { name, value } = event.target;

    setNewKpi((prev) => {
      const updatedKpi = { ...prev, [name]: value };

      // Remove o erro do campo preenchido
      setErrorsAddKpi((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (updatedErrors[name]) {
          delete updatedErrors[name]; // Remove o erro do campo alterado
        }
        return updatedErrors;
      });

      // Verifica se houve mudanças em relação ao estado inicial
      const isChanged = Object.keys(updatedKpi).some(
        (key) => updatedKpi[key] !== newKpi[key]
      );

      setHasChanges(isChanged); // Atualiza o estado de mudanças
      return updatedKpi;
    });
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const [isSavingInitiative, setIsSavingInitiative] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");

  const validateInitiativeForm = () => {
    const newErrors = {};
    const kpiErrors = {};
    const missing = [];

    // Aba 0
    if (!formData.initiativeName) {
      newErrors.initiativeName = "*";
      missing.push(getAltLabel("new_initiatives.fields.initiative_name", userDetails, t));
    }
    // Comentado: líder e PMO não são mais obrigatórios
    // if (!formData.initiativeLeader) {
    //   newErrors.initiativeLeader = "*";
    //   missing.push(t("new_initiatives.fields.initiative_leader"));
    // }
    // if (!formData.initiativePmo) {
    //   newErrors.initiativePmo = "*";
    //   missing.push(t("new_initiatives.fields.initiative_pmo"));
    // }
    if (!formData.branch) {
      newErrors.branch = "*";
      missing.push(
        getAltLabel("new_initiatives.fields.branch", userDetails, t)
      );
    }
    if (!formData.workfront) {
      newErrors.workfront = "*";
      missing.push(
        getAltLabel("new_initiatives.fields.workfront", userDetails, t)
      );
    }

    // if (!formData.impStartDate) {
    //   newErrors.impStartDate = "*";
    //   missing.push(t("new_initiatives.fields.imp_start_date"));
    // }
    // if (!formData.impEndDate) {
    //   newErrors.impEndDate = "*";
    //   missing.push(t("new_initiatives.fields.imp_end_date"));
    // }
    // if (!formData.resultsStartDate) {
    //   newErrors.resultsStartDate = "*";
    //   missing.push(t("new_initiatives.fields.results_start_date"));
    // }
    // if (!formData.resultsEndDate) {
    //   newErrors.resultsEndDate = "*";
    //   missing.push(t("new_initiatives.fields.results_end_date"));
    // }
    // if (selectedAccessGroups.length === 0) {
    //   newErrors.accessGroup = "*";
    //   missing.push(t("new_initiatives.fields.access_group"));
    // }

    const impStart = formData.impStartDate
      ? new Date(formData.impStartDate)
      : null;
    const impEnd = formData.impEndDate ? new Date(formData.impEndDate) : null;
    const resStart = formData.resultsStartDate
      ? new Date(formData.resultsStartDate)
      : null;
    const resEnd = formData.resultsEndDate
      ? new Date(formData.resultsEndDate)
      : null;
    // To do: Translates
    // Implementação
    if ((impStart && !impEnd) || (!impStart && impEnd)) {
      newErrors.impStartDate = t("new_initiatives.fields.start_end_message");
      newErrors.impEndDate = t("new_initiatives.fields.start_end_message");
    } else if (impStart && impEnd && impStart > impEnd) {
      newErrors.impStartDate = t("new_initiatives.fields.date_invalid_message");
      newErrors.impEndDate = t("new_initiatives.fields.date_invalid_message");
    }

    // Resultados
    if ((resStart && !resEnd) || (!resStart && resEnd)) {
      newErrors.resultsStartDate = t(
        "new_initiatives.fields.start_end_message"
      );
      newErrors.resultsEndDate = t("new_initiatives.fields.start_end_message");
    } else if (resStart && resEnd && resStart > resEnd) {
      newErrors.resultsStartDate = t(
        "new_initiatives.fields.date_invalid_message"
      );
      newErrors.resultsEndDate = t(
        "new_initiatives.fields.date_invalid_message"
      );
    }

    // Aba 1 (KPI) - Validação removida para annual_value

    // Removemos a obrigatoriedade de upload de arquivo:
    // if (!uploadedFiles[kpiId] || !uploadedFiles[kpiId].file) {
    //   kpiErrors[kpiId] = {
    //     ...(kpiErrors[kpiId] || {}),
    //     file: "*",
    //   };
    // }

    if (Object.keys(kpiErrors).length > 0) {
      newErrors.kpis = kpiErrors;
    }

    setFormErrors(newErrors);

    return {
      isValid: Object.keys(newErrors).length === 0,
      summary: missing.length
        ? `${t("new_initiatives.validation_errors")}: ${missing.join(", ")}`
        : "",
    };
  };

  const [serverError, setServerError] = useState(null);
  const [saveTooltip, setSaveTooltip] = useState("");

  const translateBackendError = (errorCode, fallbackMsg) => {
    if (!errorCode) return fallbackMsg;
    // t() retorna a própria key se não existir – ok!
    const translated = t(errorCode);
    return translated === errorCode ? fallbackMsg : translated;
  };

  const handleSaveInitiative = async () => {
    const { isValid, summary } = validateInitiativeForm();
    if (!isValid) {
      setSnackMessage(summary);
      setSnackOpen(true);
      return; // nem tenta salvar
    }
    setIsSavingInitiative(true); // desabilita botão

    try {
      const isUpdating = !!formData.initiativeUUID; // se tiver ID -> update
      const action = isUpdating ? "update" : "create"; // se quiser enviar explicitamente

      const formDataToSend = new FormData();

      // DEBUG: Log dos dados que serão enviados
      console.log("🔍 DEBUG - Dados do formulário antes de enviar:", {
        initiativeUUID: formData.initiativeUUID,
        initiativeName: formData.initiativeName,
        initiativeLeader: formData.initiativeLeader,
        initiativeLeader2: formData.initiativeLeader2,
        initiativePmo: formData.initiativePmo,
        integrationOwner: formData.integrationOwner,
        branch: formData.branch
      });

      const customFieldsSanitized = {};
      for (const [key, value] of Object.entries(customFieldValues)) {
        // Se for array (multichoices), transforma todos os itens em string
        if (Array.isArray(value)) {
          customFieldsSanitized[key] = value.map((v) => String(v));
        } else {
          customFieldsSanitized[key] = value;
        }
      }

      // Montamos o objeto JSON principal
      const mainBody = {
        // Se for update, passamos o ID
        initiativeUUID: formData.initiativeUUID,
        internalCode: formData.initiativeId,
        initiativeName: formData.initiativeName,
        initiativeLeader: formData.initiativeLeader,
        initiativeLeader2: formData.initiativeLeader2,
        initiativePmo: formData.initiativePmo,
        integrationOwner: formData.integrationOwner,
        sponsor: formData.sponsor,
        branch: formData.branch,
        workfront: formData.workfront,
        description: formData.description,
        impStartDate: formData.impStartDate,
        impEndDate: formData.impEndDate,
        resultsStartDate: formData.resultsStartDate,
        resultsEndDate: formData.resultsEndDate,
        risks: formData.risks,
        tags: selectedTags.map((t) => t.value),
        initiativeImpact: selectedImpact.map((i) => i.value),
        accessGroup: selectedAccessGroups.map((ag) => ag.value),
        customFields: customFieldsSanitized,
        // se quiser enviar "action" no JSON também:
        action,
      };

      formDataToSend.append("formData", JSON.stringify(mainBody));
      formDataToSend.append("deleted_files", JSON.stringify(deletedFiles));

      // KPI data
      const kpiData = selectedKpis.map((kpiId) => ({
        kpi_id: kpiId,
        planned_values: uploadedFiles[kpiId]?.plannedValues || [],
        file_name: uploadedFiles[kpiId]?.file?.name || null,
        blob_name: uploadedFiles[kpiId]?.blobName || null,
      }));
      formDataToSend.append("kpiData", JSON.stringify(kpiData));

      formDataToSend.append(
        "deliverablesData",
        JSON.stringify(uploadedImplementationData)
      );

      const editorsData = {
        one_page: selectedUsersInitiative.map((user) => user.value),
        implementation: selectedUsersImp.map((user) => user.value),
        results: selectedUsersResults.map((user) => user.value),
      };
      formDataToSend.append("editorsData", JSON.stringify(editorsData));

      // Adiciona o arquivo de KPI (se houver)
      selectedKpis.forEach((kpiId) => {
        const maybeFile = uploadedFiles[kpiId]?.file;
        if (maybeFile instanceof File) {
          formDataToSend.append(`kpiFile_${kpiId}`, uploadedFiles[kpiId].file);
        }
      });

      // Adiciona o Implementation Plan
      if (uploadedFiles.implementationFile) {
        formDataToSend.append(
          "implementationFile",
          uploadedFiles.implementationFile
        );
      }

      // Adiciona o Business Case (somente se habilitado)
      if (userDetails.has_business_case && uploadedFiles.businessCaseFile) {
        formDataToSend.append(
          "businessCaseFile",
          uploadedFiles.businessCaseFile
        );
      }

      // Adiciona os anexos extras (se houver)
      attachments.forEach((attachment, index) => {
        formDataToSend.append(`extraAttachments_${index}`, attachment.file);
      });

      console.log(
        "📤 Enviando dados para o backend:",
        Object.fromEntries(formDataToSend.entries())
      );

      const response = await client.post(
        "/api/save_initiative_view/",
        formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.success) {
        console.log("✅ Iniciativa salva com sucesso!");
        setSaveTooltip("Initiative saved successfully!");

        // Se for UPDATE, use o ID já existente (formData.initiativeUUID).
        // Se for CREATE, supondo que o backend retorne um new_initiative_id:
        const createdOrUpdatedId = isUpdating
          ? formData.initiativeUUID
          : (response.data.new_initiative_id || response.data.initiative_id);

        // Recarregar a lista e reselecionar a iniciativa editada/criada
        if (onReloadInitiatives) {
          onReloadInitiatives(createdOrUpdatedId);
        }
        
        // Fechar drawer após um pequeno delay
        setTimeout(() => {
          if (onCloseDrawer) onCloseDrawer();
        }, 500);
      } else {
        const { error_code, message } = response.data;
        const friendly = translateBackendError(error_code, message);
        setSaveTooltip(friendly);
        console.error("❌ Erro ao salvar a iniciativa:", response.data.message);
        setSaveTooltip(
          `Error: ${response.data.message || "Initiative Not Saved"}`
        );
        if (error_code === "initiative.errors.duplicate_id") {
          setFormErrors((prev) => ({ ...prev, initiativeId: friendly }));
        }
        if (error_code === "initiative.errors.duplicate_name") {
          setFormErrors((prev) => ({ ...prev, initiativeName: friendly }));
        }

        setServerError(friendly);
      }
    } catch (error) {
      const error_code = error.response?.data?.error_code;
      const msg = error.response?.data?.message || error.message;
      const friendly = translateBackendError(error_code, msg);

      console.error("❌ Erro na requisição:", error);
      setSaveTooltip(friendly);
      setServerError(friendly);
    } finally {
      setIsSavingInitiative(false); // reabilita botão após envio
    }
  };

  const bcBgColor = fileUploadedBC ? "#c8e6c9" : "#eee";
  const impBgColor = fileUploadedImp ? "#c8e6c9" : "#eee";
  const extraBgColor = attachments.length > 0 ? "#c8e6c9" : "#eee";

  const tabDefinitions = [
    {
      label: t("new_initiatives.tabs.initial_info"),
      visible: true,
    },
    {
      label: t("new_initiatives.tabs.planned_results"),
      visible: userDetails.has_results_info,
    },
    {
      label: userDetails.has_business_case 
        ? t("new_initiatives.tabs.business_case")
        : t("new_initiatives.tabs.implementation_plan_attachments"),
      visible: true,
    },
  ];

  const visibleTabs = tabDefinitions.filter((tab) => tab.visible);

  useEffect(() => {
    if (activeTab >= visibleTabs.length) {
      setActiveTab(0);
    }
  }, [visibleTabs.length, activeTab]);

  // Funções auxiliares (permanece inalterado, mas pode ser mantido)
  function getLeaderEmail(rawLeader, users) {
    if (!rawLeader) return "";
    let found = users.find((u) => u.email === rawLeader.trim());
    if (!found) {
      found = users.find((u) => u.name === rawLeader.trim());
    }
    return found ? found.email : "";
  }

  function getPmoEmail(rawPmo, users) {
    if (!rawPmo) return "";
    let found = users.find((u) => u.email === rawPmo.trim());
    if (!found) {
      found = users.find((u) => u.name === rawPmo.trim());
    }
    return found ? found.email : "";
  }

  const [loadingButtons, setLoadingButtons] = useState({});

  const setButtonLoading = (kpiId, buttonType, isLoading) => {
    setLoadingButtons((prev) => ({
      ...prev,
      [kpiId]: {
        ...(prev[kpiId] || {}),
        [buttonType]: isLoading,
      },
    }));
  };

  // useEffect que atualiza o formData ao editar uma iniciativa:
  useEffect(() => {
    // Executa assim que houver uma iniciativa para editar (sem depender de users/customFields)
    if (!initiativeToEdit) {
      return;
    }
    
    console.log("🔍 Preenchendo formulário para edição:", {
      initiativeId: initiativeToEdit.id,
      initiativeName: initiativeToEdit.initiative,
      usersLength: users.length,
      customFieldsLength: customFields.length
    });
    
    // Verifica se já foi executado para esta iniciativa
    if (editFormDataRef.current === initiativeToEdit.id) {
      console.log("⚠️ FormData já foi preenchido para esta iniciativa, saindo...");
      return;
    }
    
    // Limpa o ref se for uma iniciativa diferente
    if (editFormDataRef.current && editFormDataRef.current !== initiativeToEdit.id) {
      console.log("🔄 Nova iniciativa selecionada, limpando ref anterior");
      editFormDataRef.current = null;
    }
    
    try {
      // 1. Preenche dados básicos do formulário
      const leaderEmail = initiativeToEdit.leader_email || getLeaderEmail(initiativeToEdit.leader, users) || "";
      const leader2Email = initiativeToEdit.leader2_email || getLeaderEmail(initiativeToEdit.leader2, users) || "";
      const pmoEmail = initiativeToEdit.pmo_email || getPmoEmail(initiativeToEdit.pmo, users) || "";
      const integrationOwnerEmail = initiativeToEdit.integration_owner_email || getLeaderEmail(initiativeToEdit.integration_owner, users) || "";
      const sponsorEmail = initiativeToEdit.sponsor_email || getLeaderEmail(initiativeToEdit.sponsor, users) || "";


      // 2. Adiciona usuários "fantasmas" se necessário
      const extraUsers = [];
      if (leaderEmail && !users.some((u) => u.email === leaderEmail)) {
        extraUsers.push({ name: initiativeToEdit.leader, email: leaderEmail });
      }
      if (leader2Email && !users.some((u) => u.email === leader2Email)) {
        extraUsers.push({ name: initiativeToEdit.leader2, email: leader2Email });
      }
      if (pmoEmail && !users.some((u) => u.email === pmoEmail)) {
        extraUsers.push({ name: initiativeToEdit.pmo, email: pmoEmail });
      }
      if (integrationOwnerEmail && !users.some((u) => u.email === integrationOwnerEmail)) {
        extraUsers.push({ name: initiativeToEdit.integration_owner, email: integrationOwnerEmail });
      }
      if (sponsorEmail && !users.some((u) => u.email === sponsorEmail)) {
        extraUsers.push({ name: initiativeToEdit.sponsor, email: sponsorEmail });
      }
      
      if (extraUsers.length > 0) {
        setUsers((prev) => [...prev, ...extraUsers]);
      }

      // 3. Atualiza formData
      const newFormData = {
        initiativeUUID: initiativeToEdit.id || "",
        initiativeId: initiativeToEdit.id_internal || "",
        initiativeName: initiativeToEdit.initiative || "",
        initiativeLeader: leaderEmail,
        initiativeLeader2: leader2Email,
        initiativePmo: pmoEmail,
        integrationOwner: integrationOwnerEmail,
        sponsor: sponsorEmail,
        branch: initiativeToEdit.branch || "",
        workfront: initiativeToEdit.workfront || "",
        description: initiativeToEdit.description || "",
        impStartDate: initiativeToEdit.imp_start_date || "",
        impEndDate: initiativeToEdit.imp_end_date || "",
        resultsStartDate: initiativeToEdit.results_start_date || "",
        resultsEndDate: initiativeToEdit.results_end_date || "",
        risks: initiativeToEdit.risks || "",
      };

      setFormData(newFormData);

      // 4. Preenche customFields (se metadata já estiver disponível)
      if (initiativeToEdit.customFields && customFields.length > 0) {
        const sanitized = {};
        customFields.forEach((field) => {
          const value = initiativeToEdit.customFields[field.field_name];
          if (value !== undefined && value !== null) {
            sanitized[field.field_name] =
              field.field_type === "multichoices"
                ? Array.isArray(value)
                  ? value
                  : typeof value === "string"
                    ? value.split(/[,;]+/).map((v) => v.trim()).filter(Boolean)
                    : []
                : value;
          }
        });
        setCustomFieldValues(sanitized);
      }

      // 5. Preenche tags, impactos e grupos de acesso
      setSelectedTags(
        Array.from(new Set(initiativeToEdit.tags || [])).map((tag) => ({
          value: tag,
          label: tag,
        }))
      );
      
      setSelectedImpact(
        (initiativeToEdit.initiativeImpacts || []).map((imp) => ({
          value: imp,
          label: imp,
        }))
      );
      
      setSelectedAccessGroups(
        (initiativeToEdit.accessGroups || []).map((ag) => ({
          value: ag,
          label: ag,
        }))
      );

      // 6. Preenche editores
      setSelectedUsersInitiative(
        (initiativeToEdit.editors?.one_page || []).map((email) => ({
          value: email,
          label: `${users.find((u) => u.email === email)?.name || email} (${email})`,
        }))
      );
      
      setSelectedUsersImp(
        (initiativeToEdit.editors?.implementation || []).map((email) => ({
          value: email,
          label: `${users.find((u) => u.email === email)?.name || email} (${email})`,
        }))
      );
      
      setSelectedUsersResults(
        (initiativeToEdit.editors?.results || []).map((email) => ({
          value: email,
          label: `${users.find((u) => u.email === email)?.name || email} (${email})`,
        }))
      );

      // 7. Preenche anexos
      const atts = initiativeToEdit.attachments;
      if (atts && Object.keys(atts).length) {
        let business_case = null;
        let implementation_plan = null;
        let extra_files = [];

        if (Array.isArray(atts)) {
          business_case = atts.find((a) => a.file_type === "business_case");
          implementation_plan = atts.find((a) => a.file_type === "implementation_plan");
          extra_files = atts.filter((a) => a.file_type === "extra");
        } else {
          ({ business_case, implementation_plan, extra_files = [] } = atts);
        }

        if (business_case) {
          setUploadedFiles((prev) => ({
            ...prev,
            businessCaseFile: {
              name: business_case.file_name,
              blobName: business_case.blob_name,
            },
          }));
          setFileUploadedBC(true);
        }

        if (implementation_plan) {
          setUploadedFiles((prev) => ({
            ...prev,
            implementationFile: {
              name: implementation_plan.file_name,
              blobName: implementation_plan.blob_name,
            },
          }));
          setFileUploadedImp(true);
        }

        if (Array.isArray(extra_files) && extra_files.length) {
          const extras = extra_files.map((ef) => ({
            file: { name: ef.file_name },
            name: ef.file_name,
            size: null,
            blobName: ef.blob_name,
            uploaded_at: ef.uploaded_at,
          }));
          setAttachments(extras);
        }
      }

      // 8. Preenche KPIs selecionados
      if (initiativeToEdit.selectedKpis) {
        setSelectedKpis(initiativeToEdit.selectedKpis.map((k) => k.kpi_id));

        const initialUploadedFiles = {};

        initiativeToEdit.selectedKpis.forEach((k) => {
          if (k.files && k.files.length > 0) {
            const lastFile = k.files[k.files.length - 1];
            initialUploadedFiles[k.kpi_id] = {
              file: { name: lastFile.file_name },
              plannedValues: [],
              blobName: lastFile.blob_name,
            };
          }
        });

        setUploadedFiles((prev) => ({
          ...prev,
          ...initialUploadedFiles,
        }));
      }
      
      // Marca que já foi executado para esta iniciativa (campos básicos)
      editFormDataRef.current = initiativeToEdit.id;
      console.log("✅ FormData preenchido com sucesso para iniciativa:", initiativeToEdit.id);
      
    } catch (error) {
      console.error("❌ Erro ao preencher formulário:", error);
    }
  }, [initiativeToEdit, users]); // Não depende de customFields aqui

  // Preenche os customFields quando o metadata chegar (sem mexer no restante do form)
  useEffect(() => {
    if (!initiativeToEdit || customFields.length === 0) return;
    if (!initiativeToEdit.customFields) return;

    const sanitized = {};
    customFields.forEach((field) => {
      const value = initiativeToEdit.customFields[field.field_name];
      if (value !== undefined && value !== null) {
        sanitized[field.field_name] =
          field.field_type === "multichoices"
            ? Array.isArray(value)
              ? value
              : typeof value === "string"
                ? value.split(/[,;]+/).map((v) => v.trim()).filter(Boolean)
                : []
            : value;
      }
    });
    setCustomFieldValues(sanitized);
  }, [initiativeToEdit, customFields]);



  useEffect(() => {
    //If I'm creating, except the draft with each change of the formdate
    if (!initiativeToEdit) {
      sessionStorage.setItem("draftNewInitiative", JSON.stringify(formData));
    }

    //If you are in editing mode, you do nothing (do not surpass the creation draft)
  }, [formData.initiativeName, formData.initiativeLeader, formData.initiativeLeader2, formData.initiativePmo, formData.integrationOwner, formData.sponsor, formData.branch, formData.workfront, formData.description, formData.impStartDate, formData.impEndDate, formData.resultsStartDate, formData.resultsEndDate, formData.risks, initiativeToEdit]);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <ThreeDots
          color={userDetails.implementation_color}
          height={80}
          width={80}
          ariaLabel="loading"
        />
      </div>
    );
  }


  const downloadKpiTemplate = (selectedKpiId, lang, fileName) => {
    setButtonLoading(selectedKpiId, "downloadTemplate", true);
    client
      .post("/api/awake/")
      .then(() => {
        client
          .post(
            "/api/generate_kpi_template/",
            { kpi_id: selectedKpiId, lang: lang },
            {
              headers: { "Content-Type": "application/json" },
              responseType: "blob",
            }
          )
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((error) => {
            console.error("Erro ao baixar o template:", error);
          })
          .finally(() => {
            setButtonLoading(selectedKpiId, "downloadTemplate", false);
          });
      })
      .catch((error) => {
        console.error("Erro ao acordar a API:", error);
        setButtonLoading(selectedKpiId, "downloadTemplate", false);
      });
  };

  const handleDownloadKpiTemplate = (kpiId) => {
    const selectedKpi = kpis.find((kpi) => kpi.id === kpiId);
    if (selectedKpi) {
      const fileName = `KPI_Template_${selectedKpi.name}_${new Date().toISOString().slice(0, 10)}.xlsx`;
      downloadKpiTemplate(kpiId, i18n.language.toUpperCase(), fileName);
    } else {
      console.error("KPI não encontrado.");
    }
  };

  const handleDownloadUploadedKpiFile = async (kpiId) => {
    if (loadingButtons[kpiId]?.downloadUploadedFile) return;

    const uploaded = uploadedFiles[kpiId];
    if (!uploaded?.blobName) {
      console.warn("No uploaded file found for this KPI.");
      return;
    }

    const endpoint = uploaded.blobName.startsWith("temp_kpi_files/")
      ? "/api/download_temp_kpi_file/"
      : "/api/download_initiative_file/";

    setButtonLoading(kpiId, "downloadUploadedFile", true);

    try {
      /* 1️⃣ keep JWT fresh */
      await client.post("/api/awake/");

      /* 2️⃣ ask the back‑end to stream the blob (no SAS exposed) */
      const { data } = await client.post(
        endpoint,
        { blob_name: uploaded.blobName },
        { responseType: "blob" }
      );

      /* 3️⃣ trigger browser download */
      saveAs(
        new Blob([data]),
        uploaded.file?.name || uploaded.blobName.split("/").pop()
      );
    } catch (err) {
      console.error("❌ Unable to download KPI file:", err);
    } finally {
      setButtonLoading(kpiId, "downloadUploadedFile", false);
    }
  };

  const secureDownload = async (blobName, suggestedName) => {
    try {
      await client.post("/api/awake/");
      const { data } = await client.post(
        "/api/download_initiative_file/",
        { blob_name: blobName },
        { responseType: "blob" }
      );
      saveAs(new Blob([data]), suggestedName);
    } catch (err) {
      console.error("Download error:", err);
    }
  };

  const handleDownloadBusinessCase = () => {
    if (uploadedFiles.businessCaseFile?.blobName) {
      secureDownload(
        uploadedFiles.businessCaseFile.blobName,
        uploadedFiles.businessCaseFile.name
      );
    }
  };

  const hasErrorsInTab = {
    0: Object.keys(formErrors).some((k) => !k.startsWith("kpis")), // aba 0
    1: !!formErrors.kpis, // aba 1
    2: attachmentError !== "", // aba 2
  };

  /*****************************************************************
   *  COMPONENTE "FileChip" – mostra nome + ícone download + ✖
   *****************************************************************/
  const FileChip = ({ name, onDelete }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        background: "#f2f2f2",
        marginBottom: 6,
        padding: "4px 6px",
        borderRadius: 6,
        marginTop: "-10px",
        marginLeft: "10px",
        width: "263px",
      }}
    >
      <span
        style={{
          fontSize: "0.7rem",
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        title={name}
      >
        {name}
      </span>

      {/* ícone Excluir */}
      <CloseIcon
        color="secondary"
        style={{ fontSize: 18, cursor: "pointer" }}
        onClick={onDelete}
      />
    </div>
  );

  console.log("DEBUG userDetails", userDetails);

  const getKpiSubtypeTranslationKey = (kpiType, kpiSubtype) => {
    // Fallback text in case translation key is not found by t()
    const fallbacks = {
      topo: "Topo",
      financial: "Financial",
      budget: "Budget",
      specific: "Specific",
    };

    if (kpiType === "program") {
      if (kpiSubtype === "topo")
        return t("new_initiatives.fields.topo", fallbacks.topo);
      if (kpiSubtype === "financial")
        return t("new_initiatives.fields.financial", fallbacks.financial);
      if (kpiSubtype === "budget")
        return t("new_initiatives.fields.budget", fallbacks.budget);
      return ""; // Or some default for program if subtype doesn't match
    } else if (kpiType === "initiative") {
      // For KPIs of type 'initiative', all subtypes from the model are potentially valid
      if (kpiSubtype === "topo")
        return t("new_initiatives.fields.topo", fallbacks.topo);
      if (kpiSubtype === "financial")
        return t("new_initiatives.fields.financial", fallbacks.financial);
      if (kpiSubtype === "budget")
        return t("new_initiatives.fields.budget", fallbacks.budget);
      if (kpiSubtype === "specific")
        return t("new_initiatives.fields.specific", fallbacks.specific);
      return "-"; // Default for initiative if subtype doesn't match
    }
    return "-"; // Default if kpiType is unexpected
  };

  return (
    <div className={classes.drawerContent}>
      {/* Title */}
      <Typography
        variant="h4"
        style={{ marginBottom: "20px" }}
        className={classes.cardIconTitle}
      >
        {initiativeToEdit
          ? getAltLabel("new_initiatives.title_edit", userDetails, t)
          : getAltLabel("new_initiatives.title", userDetails, t)}
      </Typography>
      <GridItem
        style={{
          zIndex: 1000,
          position: "absolute",
          right: "15px",
          top: "10px",
          marginTop: "20px",
          marginRight: "3px",
        }}
      >
        <Tooltip title={saveTooltip}>
          <Button
            justIcon
            color="client"
            className={cx(classes.cardButton, {
              [classes.actionDisabled]: isSavingInitiative,
            })}
            onClick={handleSaveInitiative}
            disabled={isSavingInitiative}
          >
            {isSavingInitiative ? (
              <ThreeDots
                color="white"
                height={24}
                width={24}
                ariaLabel="loading"
              />
            ) : (
              <Save className={classes.cardButtonIcon} />
            )}
          </Button>
        </Tooltip>
        <Snackbar
          open={snackOpen}
          autoHideDuration={6000}
          onClose={() => setSnackOpen(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity="error"
            onClose={() => setSnackOpen(false)}
          >
            {snackMessage}
          </MuiAlert>
        </Snackbar>
      </GridItem>

      {/* Tabs */}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        classes={{
          root: classes.tabsRoot,
          indicator: classes.indicator,
        }}
        variant="fullWidth"
      >
        {visibleTabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <span>
                {tab.label}
                {hasErrorsInTab[index] && (
                  <span style={{ color: "red" }}> •</span>
                )}
              </span>
            }
            classes={{ root: classes.tabRoot }}
          />
        ))}
      </Tabs>

      {/* Initial Information */}
      {visibleTabs[activeTab]?.label ===
        t("new_initiatives.tabs.initial_info") &&
        /* stage_layout
          0)  Existe um stageLayout configurado?
              – true  → usa layout dinâmico (novo)
              – false → mostra layout legado (antigo)
        -------------------------------------------------------------*/
        (Array.isArray(userDetails.stage_layout) &&
        userDetails.stage_layout.length > 0 ? (
          /* ╭─  A .  L A Y O U T   D I N Â M I C O  ─────────────────── */
          <GridContainer spacing={3} style={{ marginTop: 20 }}>
            {userDetails.stage_layout.map((stage) => {
              /* 1.  Título da sessão ---------------------------------- */
              const rawLabel = i18n.language.startsWith("pt")
                ? stage.label_pt || stage.label_en
                : i18n.language.startsWith("es")
                  ? stage.label_es || stage.label_en
                  : stage.label_en;
              const title = t(`initiative.stage.${stage.stage}`, rawLabel);

              /* 2.  Cor da moldura – aqui deixei fixo na cor do cliente */
              const frameColor = clientColor;

              /* 3.  Renderização -------------------------------------- */
              return (
                <Section
                  key={stage.stage}
                  title={title}
                  clientColor={frameColor}
                >
                  {(stage.fields || []).map((fid) => {
                    /* ——— 3.1  CUSTOM FIELD ———————————————— */
                    if (fid.startsWith("custom:")) {
                      const fname = fid.split(":")[1];
                      
                      // Campos que devem ser ocultados no formulário
                      // (substituídos por campos "absoluto" como hc_reduced_absolute)
                      const hiddenCustomFields = [
                        "hc_reduced_upper",
                        "hc_reduced_lower",
                      ];
                      if (hiddenCustomFields.includes(fname)) {
                        return null;
                      }
                      
                      const meta = userDetails.customFields?.find(
                        (c) => c.field_name === fname
                      );

                      return meta ? (
                        <React.Fragment key={fid}>
                          {renderSingleCustomField(meta)}
                        </React.Fragment>
                      ) : null;
                    }

                    /* ——— 3.2  CAMPO FIXO ———————————————— */
                    const Renderer = fixedFieldRenderers[fid];
                    return Renderer ? (
                      <React.Fragment key={fid}>
                        {Renderer({
                          /* props obrigatórios */
                          formData,
                          handleChange: handleInputChange,
                          errors: formErrors,
                          classes,
                          t,
                          i18n,
                          userDetails,
                          /* extras que alguns Renderers usam */
                          branches,
                          workfronts,
                          userOptions,
                          tagOptions,
                          selectedTags,
                          setSelectedTags,
                          accessOptions,
                          selectedAccessGroups,
                          setSelectedAccessGroups,
                          customStyles,
                          impactOptions,
                          selectedImpact,
                          setSelectedImpact,

                          value: {
                            one_page: selectedUsersInitiative,
                            implementation: selectedUsersImp,
                            results: selectedUsersResults,
                          }[fid.split("_")[1]], // pega o array correto

                          setter: {
                            one_page: setSelectedUsersInitiative,
                            implementation: setSelectedUsersImp,
                            results: setSelectedUsersResults,
                          }[fid.split("_")[1]],
                        })}
                      </React.Fragment>
                    ) : null; // id não reconhecido → ignora
                  })}
                </Section>
              );
            })}
          </GridContainer>
        ) : (
          /* ╭─  B .  F A L L B A C K   L E G A D O  ─────────────────── */
          <LegacyInitialInfo
            /* repassamos todas as props que o layout antigo já usava */
            t={t}
            i18n={i18n}
            classes={classes}
            clientColor={clientColor}
            formData={formData}
            handleInputChange={handleInputChange}
            formErrors={formErrors}
            branches={branches}
            workfronts={workfronts}
            userOptions={userOptions}
            userDetails={userDetails}
            customFields={customFields}
            tagOptions={tagOptions}
            impactOptions={impactOptions}
            accessOptions={accessOptions}
            selectedTags={selectedTags}
            setSelectedTags={setSelectedTags}
            selectedImpact={selectedImpact}
            setSelectedImpact={setSelectedImpact}
            selectedAccessGroups={selectedAccessGroups}
            setSelectedAccessGroups={setSelectedAccessGroups}
            renderCustomFields={renderCustomFields}
            selectedUsersInitiative={selectedUsersInitiative}
            setSelectedUsersInitiative={setSelectedUsersInitiative}
            selectedUsersImp={selectedUsersImp}
            setSelectedUsersImp={setSelectedUsersImp}
            selectedUsersResults={selectedUsersResults}
            setSelectedUsersResults={setSelectedUsersResults}
            /* …adicione aqui qualquer outro state/handler que o
                  seu layout antigo ainda precise */
          />
        ))}

      {visibleTabs[activeTab]?.label ===
        t("new_initiatives.tabs.planned_results") && (
        <div>
          {/* FILTERS AND RESEARCH */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
              marginTop: "20px",
            }}
          >
            {/* Research field*/}
            <TextField
              label={
                <div
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  {t("new_initiatives.fields.search_kpi")}
                  <SearchIcon className={classes.searchIcon} />
                </div>
              }
              size="small"
              classes={{ root: classes.textFieldRoot }}
              InputProps={{ classes: { input: classes.inputText } }}
              InputLabelProps={{
                classes: { root: classes.labelText },
              }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
              style={{ width: "30%" }}
            />

            {/* Filter to show only selected */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2" style={{ marginRight: "10px" }}>
                {t("new_initiatives.fields.show_selected_kpis")}
              </Typography>
              <Switch
                checked={showOnlySelected}
                onChange={(e) => setShowOnlySelected(e.target.checked)}
                classes={{
                  switchBase: classes.switchBase,
                  track: classes.track,
                }}
              />
            </div>

            {/* KPI button*/}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "-5px",
                marginRight: "10px",
                right: "35px",
                zIndex: 1000,
              }}
            >
              <Tooltip title={t("new_initiatives.fields.add_kpi")}>
                <Button
                  justIcon
                  color="client"
                  className={classes.cardButton}
                  onClick={() => setIsCreateKpiOpen(true)} //Open the drawer
                >
                  <AddCircle className={classes.cardButtonIcon} />
                </Button>
              </Tooltip>
            </div>
          </div>
          <Typography
            variant="body2"
            style={{
              backgroundColor: "#f5f5f5",
              padding: "10px 14px",
              borderRadius: "6px",
              border: "1px solid #ddd",
              marginBottom: "16px",
              color: "#444",
              fontSize: "13px",
              lineHeight: 1.3,
            }}
          >
            {t("new_initiatives.fields.actions_description")}
          </Typography>
          {/* Kpis table*/}
          <TableContainer
            style={{
              overflowX: "auto", //Activates the scroll only in the table
            }}
          >
            <Table
              //className={classes.compactTable}
              stickyHeader
              size="small"
              style={{ tableLayout: "fixed", borderCollapse: "collapse" }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                  >
                    {t("new_initiatives.fields.select_kpi")}
                  </TableCell>
                  <TableCell
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      width: "170px",
                    }}
                  >
                    {t("new_initiatives.fields.kpi_name")}
                  </TableCell>
                  <TableCell
                    style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                  >
                    {t("new_initiatives.fields.kpi_type")}
                  </TableCell>
                  <TableCell
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      width: "100px",
                    }}
                  >
                    {t("new_initiatives.fields.kpi_subtype")}
                  </TableCell>
                  <TableCell
                    style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      width: "150px",
                    }}
                  >
                    {t("new_initiatives.fields.kpi_description")}
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {t("new_initiatives.fields.actions")}
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredKpis.map((kpi, index) => (
                  <TableRow key={index}>
                    {/* Checkbox */}
                    <TableCell align="center">
                      <Checkbox
                        checked={selectedKpis.includes(kpi.id)}
                        onChange={() => handleSelectKpi(kpi.id)}
                        classes={{
                          root: classes.checkboxRoot,
                        }}
                      />
                    </TableCell>

                    {/* KPI Name */}
                    <TableCell
                      style={{
                        fontSize: "0.8rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Tooltip title={kpi.name}>
                        <span>{kpi.name}</span>
                      </Tooltip>
                    </TableCell>

                    {/* KPI Type */}
                    <TableCell
                      style={{
                        fontSize: "0.7rem",
                      }}
                    >
                      {t(
                        kpi.type === "program"
                          ? "new_initiatives.fields.program_kpi"
                          : "new_initiatives.fields.specific_kpi"
                      )}
                    </TableCell>

                    {/* KPI Subtype */}
                    <TableCell
                      style={{
                        fontSize: "0.7rem",
                      }}
                    >
                      {getKpiSubtypeTranslationKey(kpi.type, kpi.subtype)}
                    </TableCell>

                    {/* KPI Description */}
                    <TableCell
                      style={{
                        maxWidth: "250px",
                        fontSize: "0.8rem",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <Tooltip title={kpi.description} arrow>
                        <span>{kpi.description}</span>
                      </Tooltip>
                    </TableCell>

                    {/* Actions */}
                    <TableCell align="center">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "2px",
                          marginBottom: "7px",
                        }}
                      >
                        {/* Download Template Button */}
                        <Tooltip
                          title={t("new_initiatives.fields.download_template")}
                        >
                          <Button
                            color="client"
                            className={`${classes.cardButton} ${
                              isButtonDisabled(kpi.id, "downloadTemplate")
                                ? classes.iconDisabled
                                : ""
                            }`}
                            onClick={() => handleDownloadKpiTemplate(kpi.id)}
                            disabled={isButtonDisabled(
                              kpi.id,
                              "downloadTemplate"
                            )}
                          >
                            {loadingButtons[kpi.id]?.downloadTemplate ? (
                              <ThreeDots
                                color="white"
                                height={24}
                                width={24}
                                ariaLabel="loading"
                              />
                            ) : (
                              <CloudDownloadIcon
                                className={classes.cardButtonIcon}
                              />
                            )}
                          </Button>
                        </Tooltip>

                        {/* Upload Completed Template Button */}
                        <Tooltip
                          title={
                            uploadError && uploadError[kpi.id]
                              ? t(uploadError[kpi.id])
                              : t(
                                  "new_initiatives.fields.upload_completed_template"
                                )
                          }
                          arrow
                        >
                          <Button
                            color="client"
                            className={cx(classes.cardButton, {
                              [classes.iconDisabled]: isButtonDisabled(
                                kpi.id,
                                "uploadFile"
                              ),
                              [classes.buttonSuccess]:
                                uploadedFiles[kpi.id] &&
                                uploadedFiles[kpi.id].file &&
                                !uploadError[kpi.id],
                              [classes.buttonError]: uploadError[kpi.id],
                              [classes.attention]:
                                formErrors.kpis &&
                                formErrors.kpis[kpi.id] &&
                                formErrors.kpis[kpi.id].file,
                            })}
                            onClick={() => {
                              setUploadError((prev) => ({
                                ...prev,
                                [kpi.id]: null,
                              }));
                              document
                                .getElementById(`file-upload-${index}`)
                                .click();
                            }}
                            disabled={isButtonDisabled(kpi.id, "uploadFile")}
                          >
                            {loadingButtons[kpi.id]?.uploadFile ? (
                              <ThreeDots
                                color="white"
                                height={24}
                                width={24}
                                ariaLabel="loading"
                              />
                            ) : (
                              <CloudUploadIcon
                                className={classes.cardButtonIcon}
                              />
                            )}
                          </Button>
                        </Tooltip>
                        <input
                          id={`file-upload-${index}`}
                          type="file"
                          style={{ display: "none" }}
                          onChange={(e) => handleUploadFileKpi(kpi.id, e)}
                        />

                        {/* Download Completed Template Button */}
                        <Tooltip
                          title={t(
                            "new_initiatives.fields.download_completed_template"
                          )}
                        >
                          <Button
                            color="client"
                            className={`${classes.cardButtonSecondary} ${
                              isButtonDisabled(
                                kpi.id,
                                "downloadUploadedFile"
                              ) || loadingButtons[kpi.id]?.downloadUploadedFile
                                ? classes.iconDisabled
                                : ""
                            }`}
                            onClick={() =>
                              handleDownloadUploadedKpiFile(kpi.id)
                            }
                            disabled={
                              isButtonDisabled(
                                kpi.id,
                                "downloadUploadedFile"
                              ) || loadingButtons[kpi.id]?.downloadUploadedFile
                            }
                          >
                            {loadingButtons[kpi.id]?.downloadUploadedFile ? (
                              <ThreeDots
                                color="white"
                                height={24}
                                width={24}
                                ariaLabel="loading"
                              />
                            ) : (
                              <CloudDownloadIcon
                                className={classes.cardButtonIcon}
                              />
                            )}
                          </Button>
                        </Tooltip>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Modal para Criar KPI */}
          <Dialog
            open={isCreateKpiOpen}
            onClose={() => setIsCreateKpiOpen(false)}
            maxWidth="md"
            fullWidth
            overflowY
          >
            {/* Dialog title with closing button */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <DialogTitle
                style={{ position: "relative", paddingRight: "40px" }}
              >
                {t("new_initiatives.fields.add_kpi")}
              </DialogTitle>
              <div
                style={{
                  display: "flex",
                  position: "absolute",
                  top: "20px",
                  right: "17px",
                  gap: "4px",
                }}
              >
                <CloseIcon
                  className={classes.iconButtonCustom}
                  onClick={() => setIsCreateKpiOpen(false)}
                />
                <Tooltip
                  title={
                    isSavingKpi
                      ? t("new_initiatives.fields.saving") // Exibe "Salvando..." enquanto está salvando
                      : hasChanges
                        ? t("new_initiatives.fields.save") // Exibe "Salvar" quando há mudanças
                        : t("new_initiatives.fields.no_changes")
                  }
                >
                  <span>
                    <Button
                      justIcon
                      color="client"
                      className={cx({
                        [classes.cardButtonNoMargin]: true, // Classe base do botão
                        [classes.attention]: hasChanges || isSavingKpi, // Adiciona estilo de atenção enquanto está salvando
                        [classes.actionDisabled]: !hasChanges || isSavingKpi, // Adiciona estilo de desabilitado enquanto está salvando
                      })}
                      onClick={handleSaveNewKpi}
                      disabled={
                        !hasChanges ||
                        isSavingKpi ||
                        Object.keys(errorsAddKpi).length > 0
                      }
                    >
                      <Save className={classes.cardButtonIcon} />
                    </Button>
                  </span>
                </Tooltip>
              </div>
            </div>

            {/* Dialog content */}
            <DialogContent style={{ padding: "20px", marginTop: "-20px" }}>
              <Grid container spacing={2}>
                {/* KPI Name */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={t("new_initiatives.fields.kpi_name")}
                    name="name"
                    value={newKpi.name}
                    error={!!errorsAddKpi.name} // Exibe erro se estiver vazio
                    helperText={errorsAddKpi.name} // Mensagem de erro
                    onChange={handleNewKpiChange}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                  />
                </Grid>

                {/* KPI Performance Orientation */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label={t(
                      "new_initiatives.fields.kpi_performance_orientation"
                    )}
                    name="performance_orientation" // <<< MUDE DE 'type' PARA 'performance_orientation'
                    value={newKpi.performance_orientation} // <<< MUDE DE newKpi.type
                    error={!!errorsAddKpi.performance_orientation} // Atualizar se validar este campo
                    helperText={errorsAddKpi.performance_orientation}
                    onChange={(event) => {
                      // <<< ATUALIZAR ESTE onChange
                      const newOrientation = event.target.value;
                      setNewKpi((prev) => ({
                        ...prev,
                        performance_orientation: newOrientation,
                        // Reseta todos os campos de valor de threshold
                        green_threshold_value: "",
                        green_max_value: "",
                        yellow_threshold_value: "",
                        yellow_max_value: "",
                        yellow_min_value_2: "",
                        yellow_max_value_2: "",
                        red_threshold_value: "",
                        red_modular_below_value: "",
                        red_modular_above_value: "",
                      }));
                      setHasChanges(true); // Marcar que houve mudanças
                      // Limpar erros específicos dos campos de threshold se necessário
                      setErrorsAddKpi((prevErrors) => ({
                        ...prevErrors,
                        greenThreshold: undefined,
                        greenMin: undefined,
                        greenMax: undefined,
                        yellowThreshold: undefined,
                        yellowMin: undefined,
                        yellowMax: undefined,
                        redThreshold: undefined,
                        redMin: undefined,
                        redMax: undefined,
                      }));
                    }}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                  >
                    {kpiPerformanceOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* KPI SubType */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label={t("new_initiatives.fields.kpi_subtype")}
                    name="subtype"
                    value={newKpi.subtype}
                    error={!!errorsAddKpi.subtype}
                    helperText={errorsAddKpi.subtype}
                    onChange={handleNewKpiChange}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                  >
                    {kpiSubTypeOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* KPI Description */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label={t("new_initiatives.fields.kpi_description")}
                    name="description"
                    value={newKpi.description}
                    onChange={handleNewKpiChange}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{
                      classes: { root: classes.labelText },
                      shrink: true,
                    }}
                  />
                </Grid>

                {/* Explicação dos thresholds */}
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    style={{
                      marginBottom: "1px",
                      marginTop: "7px",
                      fontStyle: "italic",
                      color: "#555",
                    }}
                  >
                    {t("new_initiatives.fields.thresholds_explanation")}
                  </Typography>
                </Grid>

                {/* THRESHOLDS - Definição baseada em Performance Orientation */}
                {newKpi.performance_orientation && ( // Só renderiza se uma orientação foi escolhida
                  <Grid
                    container
                    spacing={2}
                    item
                    xs={12}
                    style={{ marginTop: "10px" }}
                  >
                    {["green", "yellow", "red"].map((color) => {
                      const orientation = newKpi.performance_orientation;
                      let isBetween = false;
                      let singleValueLabel = t(
                        "new_initiatives.fields.threshold_value"
                      );
                      let conditionText = "";

                      if (orientation === "ASC") {
                        if (color === "green") {
                          conditionText = t("new_initiatives.fields.above");
                        } else if (color === "yellow") {
                          isBetween = true;
                          conditionText = t("new_initiatives.fields.between");
                        } else if (color === "red") {
                          conditionText = t("new_initiatives.fields.below");
                        }
                      } else if (orientation === "DESC") {
                        if (color === "green") {
                          conditionText = t("new_initiatives.fields.below");
                        } else if (color === "yellow") {
                          isBetween = true;
                          conditionText = t("new_initiatives.fields.between");
                        } else if (color === "red") {
                          conditionText = t("new_initiatives.fields.above");
                        }
                      } else if (orientation === "MOD") {
                        if (color === "green") {
                          isBetween = true;
                          conditionText = t("new_initiatives.fields.between");
                        } else if (color === "yellow") {
                          isBetween = true;
                          conditionText = t(
                            "program_setup.kpis.drawer.yellow_mod_condition"
                          );
                        } else if (color === "red") {
                          conditionText = t(
                            "program_setup.kpis.drawer.red_mod_condition"
                          );
                        }
                      }

                      const colorHex =
                        color === "green"
                          ? "green"
                          : color === "yellow"
                            ? "#e6b800"
                            : "red"; // #e6b800 é um amarelo mais visível

                      return (
                        <Grid item xs={12} md={4} key={`modal-kpi-${color}`}>
                          <Typography
                            variant="body2"
                            style={{
                              fontWeight: "bold",
                              marginBottom: "4px",
                              color: colorHex,
                            }}
                          >
                            {t(`new_initiatives.fields.${color}_condition`)}
                          </Typography>
                          <span
                            style={{
                              display: "block",
                              marginBottom: "10px",
                              fontSize: "0.8rem",
                              fontStyle: "italic",
                            }}
                          >
                            {conditionText || "-"}
                          </span>

                          {/* GREEN */}
                          {color === "green" && (
                            <>
                              {(orientation === "ASC" ||
                                orientation === "DESC") && (
                                <TextField
                                  fullWidth
                                  type="number"
                                  label={singleValueLabel} // Label já ajustado acima
                                  name="green_min_value" // Usamos green_min_value para o valor único
                                  value={newKpi.green_min_value}
                                  error={!!errorsAddKpi.green_min_value} // Adicionar validação se necessário
                                  helperText={errorsAddKpi.green_min_value}
                                  onChange={handleNewKpiChange}
                                  InputProps={{
                                    endAdornment: <span>%</span>,
                                    classes: { input: classes.inputText },
                                  }}
                                  classes={{ root: classes.textFieldRoot }}
                                  InputLabelProps={{
                                    classes: { root: classes.labelText },
                                  }}
                                  variant="standard" // Mantendo o estilo original do modal
                                />
                              )}
                              {orientation === "MOD" && (
                                <Grid container spacing={1}>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      type="number"
                                      label={t(
                                        "new_initiatives.fields.min_value"
                                      )}
                                      name="green_min_value"
                                      value={newKpi.green_min_value}
                                      error={!!errorsAddKpi.green_min_value}
                                      helperText={errorsAddKpi.green_min_value}
                                      onChange={handleNewKpiChange}
                                      InputProps={{
                                        endAdornment: <span>%</span>,
                                        classes: { input: classes.inputText },
                                      }}
                                      classes={{ root: classes.textFieldRoot }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                      variant="standard"
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      type="number"
                                      label={t(
                                        "new_initiatives.fields.max_value"
                                      )}
                                      name="green_max_value"
                                      value={newKpi.green_max_value}
                                      error={!!errorsAddKpi.green_max_value}
                                      helperText={errorsAddKpi.green_max_value}
                                      onChange={handleNewKpiChange}
                                      InputProps={{
                                        endAdornment: <span>%</span>,
                                        classes: { input: classes.inputText },
                                      }}
                                      classes={{ root: classes.textFieldRoot }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                      variant="standard"
                                    />
                                  </Grid>
                                </Grid>
                              )}
                            </>
                          )}

                          {/* YELLOW */}
                          {color === "yellow" && (
                            <>
                              <Grid container spacing={1}>
                                <Grid item xs={6}>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    label={
                                      t("new_initiatives.fields.min_value") +
                                      (orientation === "MOD" ? " (1)" : "")
                                    }
                                    name="yellow_min_value_1"
                                    value={newKpi.yellow_min_value_1}
                                    error={!!errorsAddKpi.yellow_min_value_1}
                                    helperText={errorsAddKpi.yellow_min_value_1}
                                    onChange={handleNewKpiChange}
                                    InputProps={{
                                      endAdornment: <span>%</span>,
                                      classes: { input: classes.inputText },
                                    }}
                                    classes={{ root: classes.textFieldRoot }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                    variant="standard"
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    label={
                                      t("new_initiatives.fields.max_value") +
                                      (orientation === "MOD" ? " (1)" : "")
                                    }
                                    name="yellow_max_value_1"
                                    value={newKpi.yellow_max_value_1}
                                    error={!!errorsAddKpi.yellow_max_value_1}
                                    helperText={errorsAddKpi.yellow_max_value_1}
                                    onChange={handleNewKpiChange}
                                    InputProps={{
                                      endAdornment: <span>%</span>,
                                      classes: { input: classes.inputText },
                                    }}
                                    classes={{ root: classes.textFieldRoot }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                    variant="standard"
                                  />
                                </Grid>
                              </Grid>
                              {orientation === "MOD" && (
                                <div
                                  style={{
                                    marginTop: "15px",
                                    paddingTop: "15px",
                                    borderTop: "1px dashed #e0e0e0",
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    display="block"
                                    style={{
                                      marginBottom: "10px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {t(
                                      "program_setup.kpis.drawer.optional_second_range"
                                    )}
                                  </Typography>
                                  <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                      <TextField
                                        fullWidth
                                        type="number"
                                        label={`${t("new_initiatives.fields.min_value")} (2)`}
                                        name="yellow_min_value_2"
                                        value={newKpi.yellow_min_value_2}
                                        error={
                                          !!errorsAddKpi.yellow_min_value_2
                                        }
                                        helperText={
                                          errorsAddKpi.yellow_min_value_2
                                        }
                                        onChange={handleNewKpiChange}
                                        InputProps={{
                                          endAdornment: <span>%</span>,
                                          classes: { input: classes.inputText },
                                        }}
                                        classes={{
                                          root: classes.textFieldRoot,
                                        }}
                                        InputLabelProps={{
                                          classes: { root: classes.labelText },
                                        }}
                                        variant="standard"
                                      />
                                    </Grid>
                                    <Grid item xs={6}>
                                      <TextField
                                        fullWidth
                                        type="number"
                                        label={`${t("new_initiatives.fields.max_value")} (2)`}
                                        name="yellow_max_value_2"
                                        value={newKpi.yellow_max_value_2}
                                        error={
                                          !!errorsAddKpi.yellow_max_value_2
                                        }
                                        helperText={
                                          errorsAddKpi.yellow_max_value_2
                                        }
                                        onChange={handleNewKpiChange}
                                        InputProps={{
                                          endAdornment: <span>%</span>,
                                          classes: { input: classes.inputText },
                                        }}
                                        classes={{
                                          root: classes.textFieldRoot,
                                        }}
                                        InputLabelProps={{
                                          classes: { root: classes.labelText },
                                        }}
                                        variant="standard"
                                      />
                                    </Grid>
                                  </Grid>
                                </div>
                              )}
                            </>
                          )}

                          {/* RED */}
                          {color === "red" && (
                            <>
                              {(orientation === "ASC" ||
                                orientation === "DESC") && (
                                <TextField
                                  fullWidth
                                  type="number"
                                  label={t(
                                    "new_initiatives.fields.threshold_value"
                                  )}
                                  name="red_threshold_value"
                                  value={newKpi.red_threshold_value}
                                  error={!!errorsAddKpi.red_threshold_value}
                                  helperText={errorsAddKpi.red_threshold_value}
                                  onChange={handleNewKpiChange}
                                  InputProps={{
                                    endAdornment: <span>%</span>,
                                    classes: { input: classes.inputText },
                                  }}
                                  classes={{ root: classes.textFieldRoot }}
                                  InputLabelProps={{
                                    classes: { root: classes.labelText },
                                  }}
                                  variant="standard"
                                />
                              )}
                              {orientation === "MOD" && (
                                <>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    label={t(
                                      "program_setup.kpis.drawer.red_below_value_label"
                                    )}
                                    name="red_modular_below_value"
                                    value={newKpi.red_modular_below_value}
                                    error={
                                      !!errorsAddKpi.red_modular_below_value
                                    }
                                    helperText={
                                      errorsAddKpi.red_modular_below_value
                                    }
                                    onChange={handleNewKpiChange}
                                    InputProps={{
                                      endAdornment: <span>%</span>,
                                      classes: { input: classes.inputText },
                                    }}
                                    classes={{ root: classes.textFieldRoot }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                    variant="standard"
                                    style={{ marginBottom: "10px" }}
                                  />
                                  <TextField
                                    fullWidth
                                    type="number"
                                    label={t(
                                      "program_setup.kpis.drawer.red_above_value_label"
                                    )}
                                    name="red_modular_above_value"
                                    value={newKpi.red_modular_above_value}
                                    error={
                                      !!errorsAddKpi.red_modular_above_value
                                    }
                                    helperText={
                                      errorsAddKpi.red_modular_above_value
                                    }
                                    onChange={handleNewKpiChange}
                                    InputProps={{
                                      endAdornment: <span>%</span>,
                                      classes: { input: classes.inputText },
                                    }}
                                    classes={{ root: classes.textFieldRoot }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                    variant="standard"
                                  />
                                </>
                              )}
                            </>
                          )}
                        </Grid>
                      );
                    })}
                  </Grid>
                )}
              </Grid>
            </DialogContent>
          </Dialog>
        </div>
      )}

      {(visibleTabs[activeTab]?.label === t("new_initiatives.tabs.business_case") ||
        visibleTabs[activeTab]?.label === t("new_initiatives.tabs.implementation_plan_attachments")) && (
        <div style={{ padding: "15px" }}>
          <Grid container spacing={3}>
            {/* CARD 1: Business Case - Condicional baseado em has_business_case */}
            {userDetails.has_business_case && (
              <Grid item xs={12} md={4}>
                <div
                  className={classes.inputBox}
                  style={{
                    position: "relative",
                    borderRadius: "8px",
                    padding: "20px",
                    cursor: "pointer",
                    minHeight: "220px",
                    backgroundColor: bcBgColor,
                  }}
                >
                  {/* "File" title*/}
                  <Tooltip
                    title={t("new_initiatives.fields.business_case_explanation")}
                  >
                    <div
                      className={classes.sectionTitle}
                      style={{ marginBottom: "5px" }}
                    >
                      {t("new_initiatives.fields.business_case_section")}
                    </div>
                  </Tooltip>

                  {/* Central file icon*/}
                  <div
                    style={{
                      position: "absolute",
                      textAlign: "center",
                      top: "47%",
                      left: "50%",
                      transform: "translate(-50%,-50%)",
                      width: "170px",
                    }}
                  >
                    <InsertDriveFile
                      style={{ height: "100%", width: "100%", opacity: 0.6 }}
                    />
                  </div>

                  {/* File extension (eg pdf) */}
                  <div
                    style={{
                      position: "absolute",
                      textAlign: "center",
                      top: "55%",
                      left: "50%",
                      transform: "translate(-50%,-50%)",
                      color: "#fff",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    .xlsx
                  </div>

                  {/* UPLOAD STATUS (CloudUploadRounded)*/}
                  <Tooltip
                    title={t("new_initiatives.fields.business_case_section")}
                  >
                    <div style={{ left: "43%" }} className={classes.fileStatus}>
                      <CloudUploadRounded
                        style={{
                          height: "80%",
                          width: "80%",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          document.getElementById("file-upload-input-bc").click();
                        }}
                      />
                    </div>
                  </Tooltip>

                  {/* DATA STRUCTURE or "download" (AssignmentTurnedInRounded, por ex.) */}
                  <Tooltip
                    title={
                      fileUploadedBC
                        ? t("new_initiatives.fields.download_business_case")
                        : ""
                    }
                  >
                    <div style={{ left: "57%" }} className={classes.fileStatus}>
                      <AssignmentTurnedInRounded
                        style={{
                          height: "80%",
                          width: "80%",
                          cursor: fileUploadedBC ? "pointer" : "default",
                          opacity: fileUploadedBC ? 1 : 0.4,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (fileUploadedBC) handleDownloadBusinessCase();
                        }}
                      />
                    </div>
                  </Tooltip>

                  {/* Invisible Upload Input */}
                  <input
                    id="file-upload-input-bc"
                    type="file"
                    style={{ display: "none" }}
                    accept=".xlsx,.xls" // ou outras
                    onChange={handleUploadBusinessCase}
                  />
                </div>
                {fileUploadedBC && uploadedFiles.businessCaseFile && (
                  <FileChip
                    name={uploadedFiles.businessCaseFile.name}
                    onDelete={removeBusinessCase}
                  />
                )}
              </Grid>
            )}
            {/* Card 2: Implementation Plan (required) */}
            {userDetails.has_deliverables_info && (
              <Grid item xs={12} md={4}>
                <div
                  className={classes.inputBox}
                  style={{
                    position: "relative",
                    borderRadius: "8px",
                    padding: "20px",
                    minHeight: "220px",
                    backgroundColor: impBgColor,
                  }}
                >
                  <Tooltip
                    title={t(
                      "new_initiatives.fields.implementation_plan_explanation"
                    )}
                  >
                    <div
                      className={classes.sectionTitle}
                      style={{ marginBottom: "5px" }}
                    >
                      {t("new_initiatives.fields.planned_imp_section")}
                    </div>
                  </Tooltip>

                  {/* Central icon*/}
                  <div
                    style={{
                      position: "absolute",
                      textAlign: "center",
                      top: "47%",
                      left: "50%",
                      transform: "translate(-50%,-50%)",
                      width: "170px",
                    }}
                  >
                    <InsertDriveFile
                      style={{ height: "100%", width: "100%", opacity: 0.6 }}
                    />
                  </div>

                  {/* .XLSX */}
                  <div
                    style={{
                      position: "absolute",
                      textAlign: "center",
                      top: "55%",
                      left: "50%",
                      transform: "translate(-50%,-50%)",
                      color: "#fff",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    .xlsx
                  </div>

                  {/* TEMPLATE DOWNLOAD button */}
                  <Tooltip
                    title={t("new_initiatives.fields.download_template")}
                  >
                    <div style={{ left: "36%" }} className={classes.fileStatus}>
                      <CloudDownloadRounded
                        style={{ height: "80%", width: "80%" }}
                        onClick={handleDownloadImpPlan}
                      />
                    </div>
                  </Tooltip>

                  {/*Filled Template Upload Button*/}
                  <Tooltip
                    title={
                      impPlanError ||
                      t("new_initiatives.fields.upload_completed_template")
                    }
                    arrow
                  >
                    <div
                      style={{ left: "50%" }}
                      className={classes.fileStatus}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!impPlanLoading)
                          document
                            .getElementById("file-upload-input-imp")
                            .click();
                      }}
                    >
                      {impPlanLoading ? (
                        <ThreeDots color="white" height={24} width={24} />
                      ) : (
                        <CloudUploadRounded
                          style={{
                            height: "80%",
                            width: "80%",
                            cursor: impPlanLoading ? "default" : "pointer",
                            opacity: impPlanLoading ? 0.4 : 1,
                          }}
                        />
                      )}
                    </div>
                  </Tooltip>

                  {/* Climbed file download */}
                  <Tooltip
                    title={
                      fileUploadedImp
                        ? t(
                            "new_initiatives.fields.download_completed_template"
                          )
                        : ""
                    }
                  >
                    <div style={{ left: "64%" }} className={classes.fileStatus}>
                      <AssignmentTurnedInRounded
                        style={{
                          height: "80%",
                          width: "80%",
                          cursor: fileUploadedImp ? "pointer" : "default",
                          opacity: fileUploadedImp ? 1 : 0.4,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (fileUploadedImp) handleDownloadImpPlan();
                        }}
                      />
                    </div>
                  </Tooltip>

                  {/* INPUT INVISIBLE TO RISE IMPLEMENTATION PLAN*/}
                  <input
                    id="file-upload-input-imp"
                    type="file"
                    style={{ display: "none" }}
                    accept=".xlsx,.xls"
                    onChange={handleUploadImpPlan}
                  />
                </div>
                {fileUploadedImp && uploadedFiles.implementationFile && (
                  <FileChip
                    name={uploadedFiles.implementationFile.name}
                    onDelete={removeImpPlan}
                  />
                )}
              </Grid>
            )}
            {/* Card 3: Extra Annexes */}
            <Grid item xs={12} md={4}>
              <div
                className={classes.inputBox}
                style={{
                  position: "relative",
                  borderRadius: "8px",
                  padding: "20px",
                  minHeight: "220px",
                  backgroundColor: extraBgColor,
                }}
              >
                <Tooltip
                  title={t(
                    "new_initiatives.fields.extra_attachments_explanation",
                    {
                      max: 5,
                      sizeMB: 1,
                    }
                  )}
                >
                  <div
                    className={classes.sectionTitle}
                    style={{ marginBottom: "5px" }}
                  >
                    {t("new_initiatives.tabs.attachments")}
                  </div>
                </Tooltip>

                {/* Central icon -no specific extension*/}
                <div
                  style={{
                    position: "absolute",
                    textAlign: "center",
                    top: "47%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    width: "170px",
                  }}
                >
                  <InsertDriveFile
                    style={{ height: "100%", width: "100%", opacity: 0.6 }}
                  />
                </div>

                <div
                  style={{
                    position: "absolute",
                    textAlign: "center",
                    top: "55%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                    color: "#fff",
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  {/* uncerexious */}
                </div>

                {/* Upload icon for extra attachments*/}
                <Tooltip title={t("new_initiatives.fields.upload_attachments")}>
                  <div style={{ left: "50%" }} className={classes.fileStatus}>
                    <CloudUploadRounded
                      style={{
                        height: "80%",
                        width: "80%",
                        cursor: attachments.length < 5 ? "pointer" : "default",
                        opacity: attachments.length < 5 ? 1 : 0.4,
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (attachments.length < 5) {
                          document
                            .getElementById("file-upload-attachments")
                            .click();
                        }
                      }}
                    />
                  </div>
                </Tooltip>
              </div>
              {/* Invisible Input for Multiple Attachments*/}
              <input
                id="file-upload-attachments"
                type="file"
                multiple
                style={{ display: "none" }}
                onChange={handleAttachmentsChange}
              />

              {/* Display the attachment list (if any)*/}
              {attachments.length > 0 && (
                <div
                  style={{
                    marginTop: "-10px",
                    marginLeft: "10px",
                    width: "263px",
                    borderRadius: "12px",
                  }}
                >
                  {attachmentError && (
                    <Typography
                      variant="body2"
                      style={{ color: "red", marginBottom: "5px" }}
                    >
                      {attachmentError}
                    </Typography>
                  )}
                  {attachments.map((att, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        backgroundColor: "#f2f2f2",
                        marginBottom: "5px",
                        padding: "4px",
                        borderRadius: "4px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "0.65rem",
                          maxWidth: "90%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "wrap",
                        }}
                      >
                        {att.name}
                      </span>
                      <CloseIcon
                        color="secondary"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveAttachment(idx);
                        }}
                        style={{
                          fontSize: "16px",
                          cursor: "pointer",
                          marginTop: "2px",
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  );
}

NewInitiativeForm.propTypes = {
  initiativeToEdit: PropTypes.shape({
    id: PropTypes.string,
    id_internal: PropTypes.string,
    initiative: PropTypes.string,
    leader: PropTypes.string,
    leader2: PropTypes.string,
    pmo: PropTypes.string,
    branch: PropTypes.string,
    imp_start_date: PropTypes.string,
    imp_end_date: PropTypes.string,
    results_start_date: PropTypes.string,
    results_end_date: PropTypes.string,
    workfront: PropTypes.string,
    description: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    initiativeImpacts: PropTypes.arrayOf(PropTypes.string),
    risks: PropTypes.string,
    accessGroups: PropTypes.arrayOf(PropTypes.string),
    customFields: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.arrayOf(PropTypes.string),
      ])
    ),
    editors: PropTypes.shape({
      one_page: PropTypes.arrayOf(PropTypes.string),
      implementation: PropTypes.arrayOf(PropTypes.string),
      results: PropTypes.arrayOf(PropTypes.string),
    }),
    selectedKpis: PropTypes.arrayOf(
      PropTypes.shape({
        kpi_id: PropTypes.number,
        files: PropTypes.arrayOf(
          PropTypes.shape({
            file_name: PropTypes.string,
            file_url: PropTypes.string,
          })
        ),
      })
    ),
  }),
  onCloseDrawer: PropTypes.func, // or .isRequired if you always pass it
  onReloadInitiatives: PropTypes.func,
};
